// @ts-nocheck -- staged migration: add explicit types before removing this directive.
// English glosses for the 2,136 jōyō kanji (see joyoKanji.js), derived from
// the kanji dictionary in kanjis.js. Each kanji typically has several possible
// meanings; the most common one to three are listed here.
export const joyoKanjiMeanings = [
    { symbol: "亜", meaning: "Asia, Rank Next, Come After" },
    { symbol: "哀", meaning: "Pathetic, Grief, Sorrow" },
    { symbol: "挨", meaning: "Approach, Draw Near, Push Open" },
    { symbol: "愛", meaning: "Love, Affection, Favourite" },
    { symbol: "曖", meaning: "Dark, Not Clear" },
    { symbol: "悪", meaning: "Bad, Vice, Rascal" },
    { symbol: "握", meaning: "Grip, Hold, Mould Sushi" },
    { symbol: "圧", meaning: "Pressure, Push, Overwhelm" },
    { symbol: "扱", meaning: "Handle, Entertain, Thresh" },
    { symbol: "宛", meaning: "Address, Just Like, Fortunately" },
    { symbol: "嵐", meaning: "Storm, Tempest" },
    { symbol: "安", meaning: "Relax, Cheap, Low" },
    { symbol: "案", meaning: "Plan, Suggestion, Draft" },
    { symbol: "暗", meaning: "Darkness, Disappear, Shade" },
    { symbol: "以", meaning: "By Means Of, Because, In View Of" },
    { symbol: "衣", meaning: "Garment, Clothes, Dressing" },
    { symbol: "位", meaning: "Rank, Grade, Throne" },
    { symbol: "囲", meaning: "Surround, Besiege, Store" },
    { symbol: "医", meaning: "Doctor, Medicine" },
    { symbol: "依", meaning: "Reliant, Depend On, Consequently" },
    { symbol: "委", meaning: "Committee, Entrust To, Leave To" },
    { symbol: "威", meaning: "Intimidate, Dignity, Majesty" },
    { symbol: "為", meaning: "Do, Change, Make" },
    { symbol: "畏", meaning: "Fear, Majestic, Graciously" },
    { symbol: "胃", meaning: "Stomach, Paunch, Crop" },
    { symbol: "尉", meaning: "Military Officer, Jailer, Old Man" },
    { symbol: "異", meaning: "Uncommon, Different, Queerness" },
    { symbol: "移", meaning: "Shift, Move, Change" },
    { symbol: "萎", meaning: "Wither, Droop, Lame" },
    { symbol: "偉", meaning: "Admirable, Greatness, Remarkable" },
    { symbol: "椅", meaning: "Chair" },
    { symbol: "彙", meaning: "Same Kind, Collect, Classify" },
    { symbol: "意", meaning: "Idea, Mind, Heart" },
    { symbol: "違", meaning: "Difference, Differ" },
    { symbol: "維", meaning: "Fiber, Tie, Rope" },
    { symbol: "慰", meaning: "Consolation, Amusement, Seduce" },
    { symbol: "遺", meaning: "Bequeath, Leave Behind, Reserve" },
    { symbol: "緯", meaning: "Horizontal, Woof, Left & Right" },
    { symbol: "域", meaning: "Range, Region, Limits" },
    { symbol: "育", meaning: "Bring Up, Grow Up, Raise" },
    { symbol: "一", meaning: "One" },
    { symbol: "壱", meaning: "One (in Documents)" },
    { symbol: "逸", meaning: "Deviate, Idleness, Leisure" },
    { symbol: "茨", meaning: "Briar, Thorn" },
    { symbol: "芋", meaning: "Potato" },
    { symbol: "引", meaning: "Pull, Tug, Jerk" },
    { symbol: "印", meaning: "Stamp, Seal, Mark" },
    { symbol: "因", meaning: "Cause, Factor, Be Associated With" },
    { symbol: "咽", meaning: "Throat, Choked, Smothered" },
    { symbol: "姻", meaning: "Matrimony, Marry" },
    { symbol: "員", meaning: "Employee, Member, Number" },
    { symbol: "院", meaning: "Inst., Institution, Temple" },
    { symbol: "淫", meaning: "Lewdness, Licentiousness" },
    { symbol: "陰", meaning: "Shade, Yin, Negative" },
    { symbol: "飲", meaning: "Drink, Smoke, Take" },
    { symbol: "隠", meaning: "Conceal, Hide, Cover" },
    { symbol: "韻", meaning: "Rhyme, Elegance, Tone" },
    { symbol: "右", meaning: "Right" },
    { symbol: "宇", meaning: "Eaves, Roof, House" },
    { symbol: "羽", meaning: "Feathers, Counter For Birds, Rabbits" },
    { symbol: "雨", meaning: "Rain" },
    { symbol: "唄", meaning: "Song, Ballad" },
    { symbol: "鬱", meaning: "Gloom, Depression, Melancholy" },
    { symbol: "畝", meaning: "Furrow, Thirty Tsubo, Ridge" },
    { symbol: "浦", meaning: "Bay, Creek, Inlet" },
    { symbol: "運", meaning: "Carry, Luck, Destiny" },
    { symbol: "雲", meaning: "Cloud" },
    { symbol: "永", meaning: "Eternity, Long, Lengthy" },
    { symbol: "泳", meaning: "Swim" },
    { symbol: "英", meaning: "England, English, Hero" },
    { symbol: "映", meaning: "Reflect, Reflection, Projection" },
    { symbol: "栄", meaning: "Flourish, Prosperity, Honor" },
    { symbol: "営", meaning: "Occupation, Camp, Perform" },
    { symbol: "詠", meaning: "Recitation, Poem, Song" },
    { symbol: "影", meaning: "Shadow, Silhouette, Phantom" },
    { symbol: "鋭", meaning: "Pointed, Sharpness, Edge" },
    { symbol: "衛", meaning: "Defense, Protection" },
    { symbol: "易", meaning: "Easy, Ready To, Simple" },
    { symbol: "疫", meaning: "Epidemic" },
    { symbol: "益", meaning: "Benefit, Gain, Profit" },
    { symbol: "液", meaning: "Fluid, Liquid, Juice" },
    { symbol: "駅", meaning: "Station" },
    { symbol: "悦", meaning: "Ecstasy, Joy, Rapture" },
    { symbol: "越", meaning: "Surpass, Cross Over, Move To" },
    { symbol: "謁", meaning: "Audience, Audience (with King)" },
    { symbol: "閲", meaning: "Review, Inspection, Revision" },
    { symbol: "円", meaning: "Circle, Yen, Round" },
    { symbol: "延", meaning: "Prolong, Stretching" },
    { symbol: "沿", meaning: "Run Alongside, Follow Along, Run Along" },
    { symbol: "炎", meaning: "Inflammation, Flame, Blaze" },
    { symbol: "怨", meaning: "Grudge, Show Resentment, Be Jealous" },
    { symbol: "宴", meaning: "Banquet, Feast, Party" },
    { symbol: "媛", meaning: "Beautiful Woman, Princess" },
    { symbol: "援", meaning: "Abet, Help, Save" },
    { symbol: "園", meaning: "Park, Garden, Yard" },
    { symbol: "煙", meaning: "Smoke" },
    { symbol: "猿", meaning: "Monkey" },
    { symbol: "遠", meaning: "Distant, Far" },
    { symbol: "鉛", meaning: "Lead" },
    { symbol: "塩", meaning: "Salt" },
    { symbol: "演", meaning: "Performance, Act, Play" },
    { symbol: "縁", meaning: "Affinity, Relation, Connection" },
    { symbol: "艶", meaning: "Glossy, Luster, Glaze" },
    { symbol: "汚", meaning: "Dirty, Pollute, Disgrace" },
    { symbol: "王", meaning: "King, Rule, Magnate" },
    { symbol: "凹", meaning: "Concave, Hollow, Sunken" },
    { symbol: "央", meaning: "Center, Middle" },
    { symbol: "応", meaning: "Apply, Answer, Yes" },
    { symbol: "往", meaning: "Journey, Travel, Chase Away" },
    { symbol: "押", meaning: "Push, Stop, Check" },
    { symbol: "旺", meaning: "Flourishing, Successful, Beautiful" },
    { symbol: "欧", meaning: "Europe" },
    { symbol: "殴", meaning: "Assault, Hit, Beat" },
    { symbol: "桜", meaning: "Cherry" },
    { symbol: "翁", meaning: "Venerable Old Man" },
    { symbol: "奥", meaning: "Heart, Interior" },
    { symbol: "横", meaning: "Sideways, Side, Horizontal" },
    { symbol: "岡", meaning: "Mount, Hill, Knoll" },
    { symbol: "屋", meaning: "Roof, House, Shop" },
    { symbol: "億", meaning: "Hundred Million, 10**8" },
    { symbol: "憶", meaning: "Recollection, Think, Remember" },
    { symbol: "臆", meaning: "Timidity, Heart, Mind" },
    { symbol: "虞", meaning: "Fear, Uneasiness, Anxiety" },
    { symbol: "乙", meaning: "The Latter, Duplicate, Strange" },
    { symbol: "俺", meaning: "I, Myself" },
    { symbol: "卸", meaning: "Wholesale" },
    { symbol: "音", meaning: "Sound, Noise" },
    { symbol: "恩", meaning: "Grace, Kindness, Goodness" },
    { symbol: "温", meaning: "Warm" },
    { symbol: "穏", meaning: "Calm, Quiet, Moderation" },
    { symbol: "下", meaning: "Below, Down, Descend" },
    { symbol: "化", meaning: "Change, Take The Form Of, Influence" },
    { symbol: "火", meaning: "Fire" },
    { symbol: "加", meaning: "Add, Addition, Increase" },
    { symbol: "可", meaning: "Can, Passable, Mustn't" },
    { symbol: "仮", meaning: "Sham, Temporary, Interim" },
    { symbol: "何", meaning: "What" },
    { symbol: "花", meaning: "Flower" },
    { symbol: "佳", meaning: "Excellent, Beautiful, Good" },
    { symbol: "価", meaning: "Value, Price" },
    { symbol: "果", meaning: "Fruit, Reward, Carry Out" },
    { symbol: "河", meaning: "River" },
    { symbol: "苛", meaning: "Torment, Scold, Chastise" },
    { symbol: "科", meaning: "Department, Course, Section" },
    { symbol: "架", meaning: "Erect, Frame, Mount" },
    { symbol: "夏", meaning: "Summer" },
    { symbol: "家", meaning: "House, Home, Family" },
    { symbol: "荷", meaning: "Baggage, Shoulder-pole Load, Bear (a Burden)" },
    { symbol: "華", meaning: "Splendor, Flower, Petal" },
    { symbol: "菓", meaning: "Candy, Cakes, Fruit" },
    { symbol: "貨", meaning: "Freight, Goods, Property" },
    { symbol: "渦", meaning: "Whirlpool, Eddy, Vortex" },
    { symbol: "過", meaning: "Overdo, Exceed, Go Beyond" },
    { symbol: "嫁", meaning: "Marry Into, Bride" },
    { symbol: "暇", meaning: "Spare Time, Rest, Leisure" },
    { symbol: "禍", meaning: "Calamity, Misfortune, Evil" },
    { symbol: "靴", meaning: "Shoes" },
    { symbol: "寡", meaning: "Widow, Minority, Few" },
    { symbol: "歌", meaning: "Song, Sing" },
    { symbol: "箇", meaning: "Counter For Articles" },
    { symbol: "稼", meaning: "Earnings, Work, Earn Money" },
    { symbol: "課", meaning: "Chapter, Lesson, Section" },
    { symbol: "蚊", meaning: "Mosquito" },
    { symbol: "牙", meaning: "Tusk, Fang" },
    { symbol: "瓦", meaning: "Tile, Gram" },
    { symbol: "我", meaning: "Ego, I, Selfish" },
    { symbol: "画", meaning: "Brush-stroke, Picture" },
    { symbol: "芽", meaning: "Bud, Sprout, Spear" },
    { symbol: "賀", meaning: "Congratulations, Joy" },
    { symbol: "雅", meaning: "Gracious, Elegant, Graceful" },
    { symbol: "餓", meaning: "Starve, Hungry, Thirst" },
    { symbol: "介", meaning: "Jammed In, Shellfish, Mediate" },
    { symbol: "回", meaning: "-times, Round, Game" },
    { symbol: "灰", meaning: "Ashes, Puckery Juice, Cremate" },
    { symbol: "会", meaning: "Meeting, Meet, Party" },
    { symbol: "快", meaning: "Cheerful, Pleasant, Agreeable" },
    { symbol: "戒", meaning: "Commandment" },
    { symbol: "改", meaning: "Reformation, Change, Modify" },
    { symbol: "怪", meaning: "Suspicious, Mystery, Apparition" },
    { symbol: "拐", meaning: "Kidnap, Falsify" },
    { symbol: "悔", meaning: "Repent, Regret" },
    { symbol: "海", meaning: "Sea, Ocean" },
    { symbol: "界", meaning: "World, Boundary" },
    { symbol: "皆", meaning: "All, Everything" },
    { symbol: "械", meaning: "Contraption, Fetter, Machine" },
    { symbol: "絵", meaning: "Picture, Drawing, Painting" },
    { symbol: "開", meaning: "Open, Unfold, Unseal" },
    { symbol: "階", meaning: "Storey, Stair, Counter For Storeys Of A Building" },
    { symbol: "塊", meaning: "Clod, Lump, Chunk" },
    { symbol: "楷", meaning: "Square Character Style, Correctness" },
    { symbol: "解", meaning: "Unravel, Notes, Key" },
    { symbol: "潰", meaning: "Crush, Smash, Break" },
    { symbol: "壊", meaning: "Demolition, Break, Destroy" },
    { symbol: "懐", meaning: "Pocket, Feelings, Heart" },
    { symbol: "諧", meaning: "Harmony" },
    { symbol: "貝", meaning: "Shellfish" },
    { symbol: "外", meaning: "Outside" },
    { symbol: "劾", meaning: "Censure, Criminal Investigation" },
    { symbol: "害", meaning: "Harm, Injury" },
    { symbol: "崖", meaning: "Cliff, Bluff, Precipice" },
    { symbol: "涯", meaning: "Horizon, Shore, Limit" },
    { symbol: "街", meaning: "Boulevard, Street, Town" },
    { symbol: "慨", meaning: "Rue, Be Sad, Sigh" },
    { symbol: "蓋", meaning: "Cover, Lid, Flap" },
    { symbol: "該", meaning: "Above-stated, The Said, That Specific" },
    { symbol: "概", meaning: "Outline, Condition, Approximation" },
    { symbol: "骸", meaning: "Bone, Body, Corpse" },
    { symbol: "垣", meaning: "Hedge, Fence, Wall" },
    { symbol: "柿", meaning: "Persimmon" },
    { symbol: "各", meaning: "Each, Every, Either" },
    { symbol: "角", meaning: "Angle, Corner, Square" },
    { symbol: "拡", meaning: "Broaden, Extend, Expand" },
    { symbol: "革", meaning: "Leather, Skin, Reform" },
    { symbol: "格", meaning: "Status, Rank, Capacity" },
    { symbol: "核", meaning: "Nucleus, Core, Kernel" },
    { symbol: "殻", meaning: "Husk, Nut Shell" },
    { symbol: "郭", meaning: "Enclosure, Quarters, Fortification" },
    { symbol: "覚", meaning: "Memorize, Learn, Remember" },
    { symbol: "較", meaning: "Contrast, Compare" },
    { symbol: "隔", meaning: "Isolate, Alternate, Distance" },
    { symbol: "閣", meaning: "Tower, Tall Building, Palace" },
    { symbol: "確", meaning: "Assurance, Firm, Tight" },
    { symbol: "獲", meaning: "Seize, Get, Find" },
    { symbol: "嚇", meaning: "Menacing, Dignity, Majesty" },
    { symbol: "穫", meaning: "Harvest, Reap" },
    { symbol: "学", meaning: "Study, Learning, Science" },
    { symbol: "岳", meaning: "Point, Peak, Mountain" },
    { symbol: "楽", meaning: "Music, Comfort, Ease" },
    { symbol: "額", meaning: "Forehead, Tablet, Plaque" },
    { symbol: "顎", meaning: "Jaw, Chin, Gill" },
    { symbol: "掛", meaning: "Hang, Suspend, Depend" },
    { symbol: "潟", meaning: "Lagoon" },
    { symbol: "括", meaning: "Fasten, Tie Up, Arrest" },
    { symbol: "活", meaning: "Lively, Resuscitation, Being Helped" },
    { symbol: "喝", meaning: "Hoarse, Scold" },
    { symbol: "渇", meaning: "Thirst, Dry Up, Parch" },
    { symbol: "割", meaning: "Proportion, Comparatively, Divide" },
    { symbol: "葛", meaning: "Arrowroot, Kudzu" },
    { symbol: "滑", meaning: "Slippery, Slide, Slip" },
    { symbol: "褐", meaning: "Brown, Woollen Kimono" },
    { symbol: "轄", meaning: "Control, Wedge" },
    { symbol: "且", meaning: "Moreover, Also, Furthermore" },
    { symbol: "株", meaning: "Stocks, Stump, Shares" },
    { symbol: "釜", meaning: "Kettle, Cauldron, Iron Pot" },
    { symbol: "鎌", meaning: "Sickle, Scythe, Trick" },
    { symbol: "刈", meaning: "Reap, Cut, Clip" },
    { symbol: "干", meaning: "Dry, Parch, Ebb" },
    { symbol: "刊", meaning: "Publish, Carve, Engrave" },
    { symbol: "甘", meaning: "Sweet, Coax, Pamper" },
    { symbol: "汗", meaning: "Sweat, Perspire" },
    { symbol: "缶", meaning: "Tin Can, Container" },
    { symbol: "完", meaning: "Perfect, Completion, End" },
    { symbol: "肝", meaning: "Liver, Pluck, Nerve" },
    { symbol: "官", meaning: "Bureaucrat, The Government, Organ" },
    { symbol: "冠", meaning: "Crown, Best, Peerless" },
    { symbol: "巻", meaning: "Scroll, Volume, Book" },
    { symbol: "看", meaning: "Watch Over, See" },
    { symbol: "陥", meaning: "Collapse, Fall Into, Cave In" },
    { symbol: "乾", meaning: "Drought, Dry, Dessicate" },
    { symbol: "勘", meaning: "Intuition, Perception, Check" },
    { symbol: "患", meaning: "Afflicted, Disease, Suffer From" },
    { symbol: "貫", meaning: "Pierce, 8 1/3lbs, Penetrate" },
    { symbol: "寒", meaning: "Cold" },
    { symbol: "喚", meaning: "Yell, Cry, Call" },
    { symbol: "堪", meaning: "Withstand, Endure, Support" },
    { symbol: "換", meaning: "Interchange, Period, Change" },
    { symbol: "敢", meaning: "Daring, Brave, Bold" },
    { symbol: "棺", meaning: "Coffin, Casket" },
    { symbol: "款", meaning: "Goodwill, Article, Section" },
    { symbol: "間", meaning: "Interval, Space" },
    { symbol: "閑", meaning: "Leisure" },
    { symbol: "勧", meaning: "Persuade, Recommend, Advise" },
    { symbol: "寛", meaning: "Tolerant, Leniency, Generosity" },
    { symbol: "幹", meaning: "Tree Trunk, Main Part, Talent" },
    { symbol: "感", meaning: "Emotion, Feeling, Sensation" },
    { symbol: "漢", meaning: "Sino-, China" },
    { symbol: "慣", meaning: "Accustomed, Get Used To, Become Experienced" },
    { symbol: "管", meaning: "Pipe, Tube, Wind Instrument" },
    { symbol: "関", meaning: "Connection, Barrier, Gateway" },
    { symbol: "歓", meaning: "Delight, Joy" },
    { symbol: "監", meaning: "Oversee, Official, Govt Office" },
    { symbol: "緩", meaning: "Slacken, Loosen, Relax" },
    { symbol: "憾", meaning: "Remorse, Regret, Be Sorry" },
    { symbol: "還", meaning: "Send Back, Return" },
    { symbol: "館", meaning: "Building, Mansion, Large Building" },
    { symbol: "環", meaning: "Ring, Circle, Link" },
    { symbol: "簡", meaning: "Simplicity, Brevity" },
    { symbol: "観", meaning: "Outlook, Look, Appearance" },
    { symbol: "韓", meaning: "Korea" },
    { symbol: "艦", meaning: "Warship" },
    { symbol: "鑑", meaning: "Specimen, Take Warning From, Learn From" },
    { symbol: "丸", meaning: "Round, Full (month), Perfection" },
    { symbol: "含", meaning: "Contain, Include, Hold In The Mouth" },
    { symbol: "岸", meaning: "Beach" },
    { symbol: "岩", meaning: "Boulder, Rock, Cliff" },
    { symbol: "玩", meaning: "Play, Take Pleasure In, Trifle With" },
    { symbol: "眼", meaning: "Eyeball" },
    { symbol: "頑", meaning: "Stubborn, Foolish, Firmly" },
    { symbol: "顔", meaning: "Face, Expression" },
    { symbol: "願", meaning: "Petition, Request, Vow" },
    { symbol: "企", meaning: "Undertake, Scheme, Design" },
    { symbol: "伎", meaning: "Deed, Skill" },
    { symbol: "危", meaning: "Dangerous, Fear, Uneasy" },
    { symbol: "机", meaning: "Desk, Table" },
    { symbol: "気", meaning: "Spirit, Mind, Air" },
    { symbol: "岐", meaning: "Branch Off, Fork In Road, Scene" },
    { symbol: "希", meaning: "Hope, Beg, Request" },
    { symbol: "忌", meaning: "Mourning, Abhor, Detestable" },
    { symbol: "汽", meaning: "Vapor, Steam" },
    { symbol: "奇", meaning: "Strange, Strangeness, Curiosity" },
    { symbol: "祈", meaning: "Pray, Wish" },
    { symbol: "季", meaning: "Seasons" },
    { symbol: "紀", meaning: "Chronicle, Account, Narrative" },
    { symbol: "軌", meaning: "Rut, Wheel, Track" },
    { symbol: "既", meaning: "Previously, Already, Long Ago" },
    { symbol: "記", meaning: "Scribe, Account, Narrative" },
    { symbol: "起", meaning: "Rouse, Wake Up, Get Up" },
    { symbol: "飢", meaning: "Hungry, Starve" },
    { symbol: "鬼", meaning: "Ghost, Devil" },
    { symbol: "帰", meaning: "Homecoming, Arrive At, Lead To" },
    { symbol: "基", meaning: "Fundamentals, Counter For Machines, Foundation" },
    { symbol: "寄", meaning: "Draw Near, Stop In, Bring Near" },
    { symbol: "規", meaning: "Standard, Measure" },
    { symbol: "亀", meaning: "Tortoise, Turtle" },
    { symbol: "喜", meaning: "Rejoice, Take Pleasure In" },
    { symbol: "幾", meaning: "How Many, How Much, How Far" },
    { symbol: "揮", meaning: "Brandish, Wave, Wag" },
    { symbol: "期", meaning: "Period, Time, Date" },
    { symbol: "棋", meaning: "Chess Piece, Japanese Chess, Shogi" },
    { symbol: "貴", meaning: "Precious, Value, Prize" },
    { symbol: "棄", meaning: "Abandon, Throw Away, Discard" },
    { symbol: "毀", meaning: "Break, Destroy, Censure" },
    { symbol: "旗", meaning: "National Flag, Banner, Standard" },
    { symbol: "器", meaning: "Utensil, Vessel, Receptacle" },
    { symbol: "畿", meaning: "Capital, Suburbs Of Capital" },
    { symbol: "輝", meaning: "Radiance, Shine, Sparkle" },
    { symbol: "機", meaning: "Loom, Mechanism, Machine" },
    { symbol: "騎", meaning: "Equestrian, Riding On Horses, Counter For Equestrians" },
    { symbol: "技", meaning: "Skill, Art, Craft" },
    { symbol: "宜", meaning: "Best Regards, Good" },
    { symbol: "偽", meaning: "Falsehood, Lie, Deceive" },
    { symbol: "欺", meaning: "Deceit, Cheat, Delude" },
    { symbol: "義", meaning: "Righteousness, Justice, Morality" },
    { symbol: "疑", meaning: "Doubt, Distrust, Be Suspicious" },
    { symbol: "儀", meaning: "Ceremony, Rule, Affair" },
    { symbol: "戯", meaning: "Frolic, Play, Sport" },
    { symbol: "擬", meaning: "Mimic, Aim (a Gun) At, Nominate" },
    { symbol: "犠", meaning: "Sacrifice" },
    { symbol: "議", meaning: "Deliberation, Consultation, Debate" },
    { symbol: "菊", meaning: "Chrysanthemum" },
    { symbol: "吉", meaning: "Good Luck, Joy, Congratulations" },
    { symbol: "喫", meaning: "Consume, Eat, Drink" },
    { symbol: "詰", meaning: "Packed, Close, Pressed" },
    { symbol: "却", meaning: "Instead, On The Contrary, Rather" },
    { symbol: "客", meaning: "Guest, Visitor, Customer" },
    { symbol: "脚", meaning: "Skids, Leg, Undercarriage" },
    { symbol: "逆", meaning: "Inverted, Reverse, Opposite" },
    { symbol: "虐", meaning: "Tyrannize, Oppress" },
    { symbol: "九", meaning: "Nine" },
    { symbol: "久", meaning: "Long Time, Old Story" },
    { symbol: "及", meaning: "Reach Out, Exert, Exercise" },
    { symbol: "弓", meaning: "Bow, Bow (archery, Violin)" },
    { symbol: "丘", meaning: "Hill, Knoll" },
    { symbol: "旧", meaning: "Old Times, Old Things, Old Friend" },
    { symbol: "休", meaning: "Rest, Day Off, Retire" },
    { symbol: "吸", meaning: "Suck, Imbibe, Inhale" },
    { symbol: "朽", meaning: "Decay, Rot, Remain In Seclusion" },
    { symbol: "臼", meaning: "Mortar" },
    { symbol: "求", meaning: "Request, Want, Wish For" },
    { symbol: "究", meaning: "Research, Study" },
    { symbol: "泣", meaning: "Cry, Weep, Moan" },
    { symbol: "急", meaning: "Hurry, Emergency, Sudden" },
    { symbol: "級", meaning: "Class, Rank, Grade" },
    { symbol: "糾", meaning: "Twist, Ask, Investigate" },
    { symbol: "宮", meaning: "Shinto Shrine, Constellations, Palace" },
    { symbol: "救", meaning: "Salvation, Save, Help" },
    { symbol: "球", meaning: "Ball, Sphere" },
    { symbol: "給", meaning: "Salary, Wage, Gift" },
    { symbol: "嗅", meaning: "Smell, Sniff, Scent" },
    { symbol: "窮", meaning: "Hard Up, Destitute, Suffer" },
    { symbol: "牛", meaning: "Cow" },
    { symbol: "去", meaning: "Gone, Past, Quit" },
    { symbol: "巨", meaning: "Gigantic, Big, Large" },
    { symbol: "居", meaning: "Reside, To Be, Exist" },
    { symbol: "拒", meaning: "Repel, Refuse, Reject" },
    { symbol: "拠", meaning: "Foothold, Based On, Follow" },
    { symbol: "挙", meaning: "Raise, Plan, Project" },
    { symbol: "虚", meaning: "Void, Emptiness, Unpreparedness" },
    { symbol: "許", meaning: "Permit, Approve" },
    { symbol: "距", meaning: "Long-distance, Spur, Fetlock" },
    { symbol: "魚", meaning: "Fish" },
    { symbol: "御", meaning: "Honorable, Manipulate, Govern" },
    { symbol: "漁", meaning: "Fishing, Fishery" },
    { symbol: "凶", meaning: "Villain, Evil, Bad Luck" },
    { symbol: "共", meaning: "Together, Both, Neither" },
    { symbol: "叫", meaning: "Shout, Exclaim, Yell" },
    { symbol: "狂", meaning: "Lunatic, Insane, Crazy" },
    { symbol: "京", meaning: "Capital, 10**16" },
    { symbol: "享", meaning: "Enjoy, Receive, Undergo" },
    { symbol: "供", meaning: "Submit, Offer, Present" },
    { symbol: "協", meaning: "Co-, Cooperation" },
    { symbol: "況", meaning: "Condition, Situation" },
    { symbol: "峡", meaning: "Gorge, Ravine" },
    { symbol: "挟", meaning: "Pinch, Between" },
    { symbol: "狭", meaning: "Cramped, Narrow, Contract" },
    { symbol: "恐", meaning: "Fear, Dread, Awe" },
    { symbol: "恭", meaning: "Respect, Reverent" },
    { symbol: "胸", meaning: "Bosom, Breast, Chest" },
    { symbol: "脅", meaning: "Threaten, Coerce" },
    { symbol: "強", meaning: "Strong" },
    { symbol: "教", meaning: "Teach, Faith, Doctrine" },
    { symbol: "郷", meaning: "Home Town, Village, Native Place" },
    { symbol: "境", meaning: "Boundary, Border, Region" },
    { symbol: "橋", meaning: "Bridge" },
    { symbol: "矯", meaning: "Rectify, Straighten, Correct" },
    { symbol: "鏡", meaning: "Mirror, Speculum, Barrel-head" },
    { symbol: "競", meaning: "Emulate, Compete With, Bid" },
    { symbol: "響", meaning: "Echo, Sound, Resound" },
    { symbol: "驚", meaning: "Wonder, Be Surprised, Frightened" },
    { symbol: "仰", meaning: "Face-up, Look Up, Depend" },
    { symbol: "暁", meaning: "Daybreak, Dawn, In The Event" },
    { symbol: "業", meaning: "Business, Vocation, Arts" },
    { symbol: "凝", meaning: "Congeal, Freeze, Stiff" },
    { symbol: "曲", meaning: "Bend, Music, Melody" },
    { symbol: "局", meaning: "Bureau, Board, Office" },
    { symbol: "極", meaning: "Poles, Settlement, Conclusion" },
    { symbol: "玉", meaning: "Jewel, Ball" },
    { symbol: "巾", meaning: "Towel, Hanging Scroll, Width" },
    { symbol: "斤", meaning: "Axe, 1.32 Lb, Catty" },
    { symbol: "均", meaning: "Level, Average" },
    { symbol: "近", meaning: "Near, Early, Akin" },
    { symbol: "金", meaning: "Gold" },
    { symbol: "菌", meaning: "Germ, Fungus, Bacteria" },
    { symbol: "勤", meaning: "Diligence, Become Employed, Serve" },
    { symbol: "琴", meaning: "Harp, Koto" },
    { symbol: "筋", meaning: "Muscle, Sinew, Tendon" },
    { symbol: "僅", meaning: "A Wee Bit" },
    { symbol: "禁", meaning: "Prohibition, Ban, Forbid" },
    { symbol: "緊", meaning: "Tense, Solid, Hard" },
    { symbol: "錦", meaning: "Brocade, Fine Dress, Honors" },
    { symbol: "謹", meaning: "Discreet, Reverently, Humbly" },
    { symbol: "襟", meaning: "Collar, Neck, Lapel" },
    { symbol: "吟", meaning: "Versify, Singing, Recital" },
    { symbol: "銀", meaning: "Silver" },
    { symbol: "区", meaning: "Ward, District" },
    { symbol: "句", meaning: "Phrase, Clause, Sentence" },
    { symbol: "苦", meaning: "Suffering, Trial, Worry" },
    { symbol: "駆", meaning: "Drive, Run, Gallop" },
    { symbol: "具", meaning: "Tool, Utensil, Means" },
    { symbol: "惧", meaning: "Fear, Be Afraid Of, Dread" },
    { symbol: "愚", meaning: "Foolish, Folly, Absurdity" },
    { symbol: "空", meaning: "Empty, Sky, Void" },
    { symbol: "偶", meaning: "Accidentally, Even Number, Couple" },
    { symbol: "遇", meaning: "Meet, Encounter, Interview" },
    { symbol: "隅", meaning: "Corner, Nook" },
    { symbol: "串", meaning: "Spit, Skewer" },
    { symbol: "屈", meaning: "Yield, Bend, Flinch" },
    { symbol: "掘", meaning: "Dig, Delve, Excavate" },
    { symbol: "窟", meaning: "Cavern" },
    { symbol: "熊", meaning: "Bear" },
    { symbol: "繰", meaning: "Winding, Reel, Spin" },
    { symbol: "君", meaning: "Mister, You, Ruler" },
    { symbol: "訓", meaning: "Instruction, Japanese Character Reading, Explanation" },
    { symbol: "勲", meaning: "Meritorious Deed, Merit" },
    { symbol: "薫", meaning: "Send Forth Fragrance, Fragrant, Be Scented" },
    { symbol: "軍", meaning: "Army, Force, Troops" },
    { symbol: "郡", meaning: "County, District" },
    { symbol: "群", meaning: "Flock, Group, Crowd" },
    { symbol: "兄", meaning: "Elder Brother, Big Brother" },
    { symbol: "刑", meaning: "Punish, Penalty, Sentence" },
    { symbol: "形", meaning: "Shape, Form, Style" },
    { symbol: "系", meaning: "Lineage, System" },
    { symbol: "径", meaning: "Diameter, Path, Method" },
    { symbol: "茎", meaning: "Stalk, Stem" },
    { symbol: "係", meaning: "Person In Charge, Connection, Duty" },
    { symbol: "型", meaning: "Mould, Type, Model" },
    { symbol: "契", meaning: "Pledge, Promise, Vow" },
    { symbol: "計", meaning: "Plot, Plan, Scheme" },
    { symbol: "恵", meaning: "Favor, Blessing, Grace" },
    { symbol: "啓", meaning: "Disclose, Open, Say" },
    { symbol: "掲", meaning: "Put Up (a Notice), Put Up, Hoist" },
    { symbol: "渓", meaning: "Mountain Stream, Valley" },
    { symbol: "経", meaning: "Sutra, Longitude, Pass Thru" },
    { symbol: "蛍", meaning: "Lightning-bug, Firefly" },
    { symbol: "敬", meaning: "Awe, Respect, Honor" },
    { symbol: "景", meaning: "Scenery, View" },
    { symbol: "軽", meaning: "Lightly, Trifling, Unimportant" },
    { symbol: "傾", meaning: "Lean, Incline, Tilt" },
    { symbol: "携", meaning: "Portable, Carry (in Hand), Armed With" },
    { symbol: "継", meaning: "Inherit, Succeed, Continue" },
    { symbol: "詣", meaning: "Visit A Temple, Arrive, Attain" },
    { symbol: "慶", meaning: "Jubilation, Congratulate, Rejoice" },
    { symbol: "憬", meaning: "Yearn For, Aspire To, Admire" },
    { symbol: "稽", meaning: "Think, Consider" },
    { symbol: "憩", meaning: "Recess, Rest, Relax" },
    { symbol: "警", meaning: "Admonish, Commandment" },
    { symbol: "鶏", meaning: "Chicken" },
    { symbol: "芸", meaning: "Technique, Art, Craft" },
    { symbol: "迎", meaning: "Welcome, Meet, Greet" },
    { symbol: "鯨", meaning: "Whale" },
    { symbol: "隙", meaning: "Crevice, Fissure, Discord" },
    { symbol: "劇", meaning: "Drama, Play" },
    { symbol: "撃", meaning: "Beat, Attack, Defeat" },
    { symbol: "激", meaning: "Violent, Get Excited, Enraged" },
    { symbol: "桁", meaning: "Beam, Girder, Spar" },
    { symbol: "欠", meaning: "Lack, Gap, Fail" },
    { symbol: "穴", meaning: "Hole, Aperture, Slit" },
    { symbol: "血", meaning: "Blood" },
    { symbol: "決", meaning: "Decide, Fix, Agree Upon" },
    { symbol: "結", meaning: "Tie, Bind, Contract" },
    { symbol: "傑", meaning: "Greatness, Excellence" },
    { symbol: "潔", meaning: "Undefiled, Pure, Clean" },
    { symbol: "月", meaning: "Month, Moon" },
    { symbol: "犬", meaning: "Dog" },
    { symbol: "件", meaning: "Affair, Case, Matter" },
    { symbol: "見", meaning: "See, Hopes, Chances" },
    { symbol: "券", meaning: "Ticket" },
    { symbol: "肩", meaning: "Shoulder" },
    { symbol: "建", meaning: "Build" },
    { symbol: "研", meaning: "Polish, Study Of, Sharpen" },
    { symbol: "県", meaning: "Prefecture" },
    { symbol: "倹", meaning: "Frugal, Economy, Thrifty" },
    { symbol: "兼", meaning: "Concurrently, And, Beforehand" },
    { symbol: "剣", meaning: "Sabre, Sword, Blade" },
    { symbol: "拳", meaning: "Fist" },
    { symbol: "軒", meaning: "Flats, Counter For Houses, Eaves" },
    { symbol: "健", meaning: "Healthy, Health, Strength" },
    { symbol: "険", meaning: "Precipitous, Inaccessible Place, Impregnable Position" },
    { symbol: "圏", meaning: "Sphere, Circle, Radius" },
    { symbol: "堅", meaning: "Strict, Hard, Solid" },
    { symbol: "検", meaning: "Examination, Investigate" },
    { symbol: "嫌", meaning: "Dislike, Detest, Hate" },
    { symbol: "献", meaning: "Offering, Counter For Drinks, Present" },
    { symbol: "絹", meaning: "Silk" },
    { symbol: "遣", meaning: "Dispatch, Despatch, Send" },
    { symbol: "権", meaning: "Authority, Power, Rights" },
    { symbol: "憲", meaning: "Constitution, Law" },
    { symbol: "賢", meaning: "Intelligent, Wise, Wisdom" },
    { symbol: "謙", meaning: "Self-effacing, Humble Oneself, Condescend" },
    { symbol: "鍵", meaning: "Key" },
    { symbol: "繭", meaning: "Cocoon" },
    { symbol: "顕", meaning: "Appear, Existing" },
    { symbol: "験", meaning: "Verification, Effect, Testing" },
    { symbol: "懸", meaning: "State Of Suspension, Hang, Depend" },
    { symbol: "元", meaning: "Beginning, Former Time, Origin" },
    { symbol: "幻", meaning: "Phantasm, Vision, Dream" },
    { symbol: "玄", meaning: "Mysterious, Occultness, Black" },
    { symbol: "言", meaning: "Say, Word" },
    { symbol: "弦", meaning: "Bowstring, Chord, Hypotenuse" },
    { symbol: "限", meaning: "Limit, Restrict, To Best Of Ability" },
    { symbol: "原", meaning: "Meadow, Original, Primitive" },
    { symbol: "現", meaning: "Present, Existing, Actual" },
    { symbol: "舷", meaning: "Gunwale" },
    { symbol: "減", meaning: "Dwindle, Decrease, Reduce" },
    { symbol: "源", meaning: "Source, Origin" },
    { symbol: "厳", meaning: "Stern, Strictness, Severity" },
    { symbol: "己", meaning: "Self" },
    { symbol: "戸", meaning: "Door, Counter For Houses" },
    { symbol: "古", meaning: "Old" },
    { symbol: "呼", meaning: "Call, Call Out To, Invite" },
    { symbol: "固", meaning: "Harden, Set, Clot" },
    { symbol: "股", meaning: "Thigh, Crotch" },
    { symbol: "虎", meaning: "Tiger, Drunkard" },
    { symbol: "孤", meaning: "Orphan, Alone" },
    { symbol: "弧", meaning: "Arc, Arch, Bow" },
    { symbol: "故", meaning: "Happenstance, Especially, Intentionally" },
    { symbol: "枯", meaning: "Wither, Die, Dry Up" },
    { symbol: "個", meaning: "Individual, Counter For Articles" },
    { symbol: "庫", meaning: "Warehouse, Storehouse" },
    { symbol: "湖", meaning: "Lake" },
    { symbol: "雇", meaning: "Employ, Hire" },
    { symbol: "誇", meaning: "Boast, Be Proud, Pride" },
    { symbol: "鼓", meaning: "Drum, Beat, Rouse" },
    { symbol: "錮", meaning: "Confinement, To Tie" },
    { symbol: "顧", meaning: "Look Back, Review, Examine Oneself" },
    { symbol: "五", meaning: "Five" },
    { symbol: "互", meaning: "Mutually, Reciprocally, Together" },
    { symbol: "午", meaning: "Noon, Sign Of The Horse, 11am-1pm" },
    { symbol: "呉", meaning: "Give, Do Something For, Kingdom Of Wu" },
    { symbol: "後", meaning: "Behind, Back, Later" },
    { symbol: "娯", meaning: "Recreation, Pleasure" },
    { symbol: "悟", meaning: "Enlightenment, Perceive, Discern" },
    { symbol: "碁", meaning: "Go" },
    { symbol: "語", meaning: "Word, Speech, Language" },
    { symbol: "誤", meaning: "Mistake, Err, Do Wrong" },
    { symbol: "護", meaning: "Safeguard, Protect" },
    { symbol: "口", meaning: "Mouth" },
    { symbol: "工", meaning: "Craft, Construction" },
    { symbol: "公", meaning: "Public, Prince, Official" },
    { symbol: "勾", meaning: "Be Bent, Slope, Capture" },
    { symbol: "孔", meaning: "Cavity, Hole, Slit" },
    { symbol: "功", meaning: "Achievement, Merits, Success" },
    { symbol: "巧", meaning: "Adroit, Skilled, Ingenuity" },
    { symbol: "広", meaning: "Wide, Broad, Spacious" },
    { symbol: "甲", meaning: "Armor, High (voice), A Grade" },
    { symbol: "交", meaning: "Mingle, Mixing, Association" },
    { symbol: "光", meaning: "Ray, Light" },
    { symbol: "向", meaning: "Yonder, Facing, Beyond" },
    { symbol: "后", meaning: "Empress, Queen, After" },
    { symbol: "好", meaning: "Fond, Pleasing, Like Something" },
    { symbol: "江", meaning: "Creek, Inlet, Bay" },
    { symbol: "考", meaning: "Consider, Think Over" },
    { symbol: "行", meaning: "Going, Journey, Carry Out" },
    { symbol: "坑", meaning: "Pit, Hole" },
    { symbol: "孝", meaning: "Filial Piety, Child's Respect" },
    { symbol: "抗", meaning: "Confront, Resist, Defy" },
    { symbol: "攻", meaning: "Aggression, Attack, Criticize" },
    { symbol: "更", meaning: "Grow Late, Night Watch, Sit Up Late" },
    { symbol: "効", meaning: "Merit, Efficacy, Efficiency" },
    { symbol: "幸", meaning: "Happiness, Blessing, Fortune" },
    { symbol: "拘", meaning: "Arrest, Seize, Concerned" },
    { symbol: "肯", meaning: "Agreement, Consent, Comply With" },
    { symbol: "侯", meaning: "Marquis, Lord, Daimyo" },
    { symbol: "厚", meaning: "Thick, Heavy, Rich" },
    { symbol: "恒", meaning: "Constancy, Always" },
    { symbol: "洪", meaning: "Deluge, Flood, Vast" },
    { symbol: "皇", meaning: "Emperor" },
    { symbol: "紅", meaning: "Crimson, Deep Red" },
    { symbol: "荒", meaning: "Laid Waste, Rough, Rude" },
    { symbol: "郊", meaning: "Outskirts, Suburbs, Rural Area" },
    { symbol: "香", meaning: "Incense, Smell, Perfume" },
    { symbol: "候", meaning: "Climate, Season, Weather" },
    { symbol: "校", meaning: "Exam, School, Printing" },
    { symbol: "耕", meaning: "Till, Plow, Cultivate" },
    { symbol: "航", meaning: "Navigate, Sail, Cruise" },
    { symbol: "貢", meaning: "Tribute, Support, Finance" },
    { symbol: "降", meaning: "Descend, Precipitate, Fall" },
    { symbol: "高", meaning: "Tall, High, Expensive" },
    { symbol: "康", meaning: "Ease, Peace" },
    { symbol: "控", meaning: "Withdraw, Draw In, Hold Back" },
    { symbol: "梗", meaning: "For The Most Part, Close Up, Flower Stem" },
    { symbol: "黄", meaning: "Yellow" },
    { symbol: "喉", meaning: "Throat, Voice" },
    { symbol: "慌", meaning: "Disconcerted, Be Confused, Lose One's Head" },
    { symbol: "港", meaning: "Harbor" },
    { symbol: "硬", meaning: "Stiff, Hard" },
    { symbol: "絞", meaning: "Strangle, Constrict, Wring" },
    { symbol: "項", meaning: "Paragraph, Nape Of Neck, Clause" },
    { symbol: "溝", meaning: "Gutter, Ditch, Sewer" },
    { symbol: "鉱", meaning: "Mineral, Ore" },
    { symbol: "構", meaning: "Posture, Build, Pretend" },
    { symbol: "綱", meaning: "Hawser, Class (genus), Rope" },
    { symbol: "酵", meaning: "Fermentation" },
    { symbol: "稿", meaning: "Draft, Copy, Manuscript" },
    { symbol: "興", meaning: "Entertain, Revive, Retrieve" },
    { symbol: "衡", meaning: "Equilibrium, Measuring Rod, Scale" },
    { symbol: "鋼", meaning: "Steel" },
    { symbol: "講", meaning: "Lecture, Club, Association" },
    { symbol: "購", meaning: "Subscription, Buy" },
    { symbol: "乞", meaning: "Beg, Invite, Ask" },
    { symbol: "号", meaning: "Nickname, Number, Item" },
    { symbol: "合", meaning: "Fit, Suit, Join" },
    { symbol: "拷", meaning: "Torture, Beat" },
    { symbol: "剛", meaning: "Sturdy, Strength" },
    { symbol: "傲", meaning: "Be Proud" },
    { symbol: "豪", meaning: "Overpowering, Great, Powerful" },
    { symbol: "克", meaning: "Overcome, Kindly, Skillfully" },
    { symbol: "告", meaning: "Revelation, Tell, Inform" },
    { symbol: "谷", meaning: "Valley" },
    { symbol: "刻", meaning: "Engrave, Cut Fine, Chop" },
    { symbol: "国", meaning: "Country" },
    { symbol: "黒", meaning: "Black" },
    { symbol: "穀", meaning: "Cereals, Grain" },
    { symbol: "酷", meaning: "Cruel, Severe, Atrocious" },
    { symbol: "獄", meaning: "Prison, Jail" },
    { symbol: "骨", meaning: "Skeleton, Bone, Remains" },
    { symbol: "駒", meaning: "Pony, Horse, Colt" },
    { symbol: "込", meaning: "Crowded, Mixture, In Bulk" },
    { symbol: "頃", meaning: "Time, About, Toward" },
    { symbol: "今", meaning: "Now" },
    { symbol: "困", meaning: "Quandary, Become Distressed, Annoyed" },
    { symbol: "昆", meaning: "Descendants, Elder Brother, Insect" },
    { symbol: "恨", meaning: "Regret, Bear A Grudge, Resentment" },
    { symbol: "根", meaning: "Root, Head (pimple)" },
    { symbol: "婚", meaning: "Marriage" },
    { symbol: "混", meaning: "Mix, Blend, Confuse" },
    { symbol: "痕", meaning: "Mark, Foot Print" },
    { symbol: "紺", meaning: "Dark Blue, Navy" },
    { symbol: "魂", meaning: "Soul, Spirit" },
    { symbol: "墾", meaning: "Ground-breaking, Open Up Farmland" },
    { symbol: "懇", meaning: "Sociable, Kind, Courteous" },
    { symbol: "左", meaning: "Left" },
    { symbol: "佐", meaning: "Assistant, Help" },
    { symbol: "沙", meaning: "Sand" },
    { symbol: "査", meaning: "Investigate" },
    { symbol: "砂", meaning: "Sand" },
    { symbol: "唆", meaning: "Tempt, Seduce, Instigate" },
    { symbol: "差", meaning: "Distinction, Difference, Variation" },
    { symbol: "詐", meaning: "Lie, Falsehood, Deceive" },
    { symbol: "鎖", meaning: "Chain, Irons, Connection" },
    { symbol: "座", meaning: "Squat, Seat, Cushion" },
    { symbol: "挫", meaning: "Crush, Break, Sprain" },
    { symbol: "才", meaning: "Genius, Years Old, Cubic Shaku" },
    { symbol: "再", meaning: "Again, Twice, Second Time" },
    { symbol: "災", meaning: "Disaster, Calamity, Woe" },
    { symbol: "妻", meaning: "Wife, Spouse" },
    { symbol: "采", meaning: "Dice, Form, Appearance" },
    { symbol: "砕", meaning: "Smash, Break, Crush" },
    { symbol: "宰", meaning: "Superintend, Manager, Rule" },
    { symbol: "栽", meaning: "Plantation, Planting" },
    { symbol: "彩", meaning: "Coloring, Paint, Makeup" },
    { symbol: "採", meaning: "Pick, Take, Fetch" },
    { symbol: "済", meaning: "Settle (debt, Etc.), Relieve (burden), Finish" },
    { symbol: "祭", meaning: "Ritual, Offer Prayers, Celebrate" },
    { symbol: "斎", meaning: "Purification, Buddhist Food, Room" },
    { symbol: "細", meaning: "Dainty, Get Thin, Taper" },
    { symbol: "菜", meaning: "Vegetable, Side Dish, Greens" },
    { symbol: "最", meaning: "Utmost, Most, Extreme" },
    { symbol: "裁", meaning: "Tailor, Judge, Decision" },
    { symbol: "債", meaning: "Bond, Loan, Debt" },
    { symbol: "催", meaning: "Sponsor, Hold (a Meeting), Give (a Dinner)" },
    { symbol: "塞", meaning: "Close, Shut, Cover" },
    { symbol: "歳", meaning: "Year-end, Age, Occasion" },
    { symbol: "載", meaning: "Ride, Board, Get On" },
    { symbol: "際", meaning: "Occasion, Side, Edge" },
    { symbol: "埼", meaning: "Cape, Spit, Promontory" },
    { symbol: "在", meaning: "Exist, Outskirts, Suburbs" },
    { symbol: "材", meaning: "Lumber, Log, Timber" },
    { symbol: "剤", meaning: "Dose, Medicine, Drug" },
    { symbol: "財", meaning: "Property, Money, Wealth" },
    { symbol: "罪", meaning: "Guilt, Sin, Crime" },
    { symbol: "崎", meaning: "Promontory, Cape, Spit" },
    { symbol: "作", meaning: "Make, Production, Prepare" },
    { symbol: "削", meaning: "Plane, Sharpen, Whittle" },
    { symbol: "昨", meaning: "Yesterday, Previous" },
    { symbol: "柵", meaning: "Stockade, Fence, Weir" },
    { symbol: "索", meaning: "Cord, Rope, Searching" },
    { symbol: "策", meaning: "Scheme, Plan, Policy" },
    { symbol: "酢", meaning: "Vinegar, Sour, Acid" },
    { symbol: "搾", meaning: "Squeeze" },
    { symbol: "錯", meaning: "Confused, Mix, Be In Disorder" },
    { symbol: "咲", meaning: "Blossom, Bloom" },
    { symbol: "冊", meaning: "Tome, Counter For Books, Volume" },
    { symbol: "札", meaning: "Tag, Paper Money, Counter For Bonds" },
    { symbol: "刷", meaning: "Printing, Print, Brush" },
    { symbol: "刹", meaning: "Temple" },
    { symbol: "拶", meaning: "Be Imminent, Draw Close" },
    { symbol: "殺", meaning: "Kill, Murder, Butcher" },
    { symbol: "察", meaning: "Guess, Presume, Surmise" },
    { symbol: "撮", meaning: "Snapshot, Take Pictures" },
    { symbol: "擦", meaning: "Grate, Rub, Scratch" },
    { symbol: "雑", meaning: "Miscellaneous" },
    { symbol: "皿", meaning: "Dish, A Helping, Plate" },
    { symbol: "三", meaning: "Three" },
    { symbol: "山", meaning: "Mountain" },
    { symbol: "参", meaning: "Nonplussed, Three (in Documents), Going" },
    { symbol: "桟", meaning: "Scaffold, Cleat, Frame" },
    { symbol: "蚕", meaning: "Silkworm" },
    { symbol: "惨", meaning: "Wretched, Disaster, Cruelty" },
    { symbol: "産", meaning: "Products, Bear, Give Birth" },
    { symbol: "傘", meaning: "Umbrella" },
    { symbol: "散", meaning: "Scatter, Disperse, Spend" },
    { symbol: "算", meaning: "Calculate, Divining, Number" },
    { symbol: "酸", meaning: "Acid, Bitterness, Sour" },
    { symbol: "賛", meaning: "Approve, Praise, Title Or Inscription On Picture" },
    { symbol: "残", meaning: "Remainder, Leftover, Balance" },
    { symbol: "斬", meaning: "Beheading, Kill, Murder" },
    { symbol: "暫", meaning: "Temporarily, A While, Moment" },
    { symbol: "士", meaning: "Gentleman, Scholar, Samurai" },
    { symbol: "子", meaning: "Child, Sign Of The Rat, 11pm-1am" },
    { symbol: "支", meaning: "Branch, Support, Sustain" },
    { symbol: "止", meaning: "Stop, Halt" },
    { symbol: "氏", meaning: "Family Name, Surname, Clan" },
    { symbol: "仕", meaning: "Attend, Doing, Official" },
    { symbol: "史", meaning: "History, Chronicle" },
    { symbol: "司", meaning: "Director, Official, Govt Office" },
    { symbol: "四", meaning: "Four" },
    { symbol: "市", meaning: "Market, City, Town" },
    { symbol: "矢", meaning: "Dart, Arrow" },
    { symbol: "旨", meaning: "Delicious, Relish, Show A Liking For" },
    { symbol: "死", meaning: "Death, Die" },
    { symbol: "糸", meaning: "Thread" },
    { symbol: "至", meaning: "Climax, Arrive, Proceed" },
    { symbol: "伺", meaning: "Pay Respects, Visit, Ask" },
    { symbol: "志", meaning: "Intention, Plan, Resolve" },
    { symbol: "私", meaning: "Private, I, Me" },
    { symbol: "使", meaning: "Use, Send On A Mission, Order" },
    { symbol: "刺", meaning: "Thorn, Pierce, Stab" },
    { symbol: "始", meaning: "Commence, Begin" },
    { symbol: "姉", meaning: "Elder Sister" },
    { symbol: "枝", meaning: "Bough, Branch, Twig" },
    { symbol: "祉", meaning: "Welfare, Happiness" },
    { symbol: "肢", meaning: "Limb, Arms & Legs" },
    { symbol: "姿", meaning: "Figure, Form, Shape" },
    { symbol: "思", meaning: "Think" },
    { symbol: "指", meaning: "Finger, Point To, Indicate" },
    { symbol: "施", meaning: "Give, Bestow, Perform" },
    { symbol: "師", meaning: "Expert, Teacher, Master" },
    { symbol: "恣", meaning: "Selfish, Arbitrary" },
    { symbol: "紙", meaning: "Paper" },
    { symbol: "脂", meaning: "Fat, Grease, Tallow" },
    { symbol: "視", meaning: "Inspection, Regard As, See" },
    { symbol: "紫", meaning: "Purple, Violet" },
    { symbol: "詞", meaning: "Part Of Speech, Words, Poetry" },
    { symbol: "歯", meaning: "Tooth, Cog" },
    { symbol: "嗣", meaning: "Heir, Succeed" },
    { symbol: "試", meaning: "Test, Try, Attempt" },
    { symbol: "詩", meaning: "Poem, Poetry" },
    { symbol: "資", meaning: "Assets, Resources, Capital" },
    { symbol: "飼", meaning: "Domesticate, Raise, Keep" },
    { symbol: "誌", meaning: "Document, Records" },
    { symbol: "雌", meaning: "Feminine, Female" },
    { symbol: "摯", meaning: "Gift, Seriousness" },
    { symbol: "賜", meaning: "Grant, Gift, Boon" },
    { symbol: "諮", meaning: "Consult With" },
    { symbol: "示", meaning: "Show, Indicate, Point Out" },
    { symbol: "字", meaning: "Character, Letter, Word" },
    { symbol: "寺", meaning: "Buddhist Temple" },
    { symbol: "次", meaning: "Next, Order, Sequence" },
    { symbol: "耳", meaning: "Ear" },
    { symbol: "自", meaning: "Oneself" },
    { symbol: "似", meaning: "Becoming, Resemble, Counterfeit" },
    { symbol: "児", meaning: "Newborn Babe, Child, Young Of Animals" },
    { symbol: "事", meaning: "Matter, Thing, Fact" },
    { symbol: "侍", meaning: "Waiter, Samurai, Wait Upon" },
    { symbol: "治", meaning: "Reign, Be At Peace, Calm Down" },
    { symbol: "持", meaning: "Hold, Have" },
    { symbol: "時", meaning: "Time, Hour" },
    { symbol: "滋", meaning: "Nourishing, More & More, Be Luxuriant" },
    { symbol: "慈", meaning: "Mercy" },
    { symbol: "辞", meaning: "Resign, Word, Term" },
    { symbol: "磁", meaning: "Magnet, Porcelain" },
    { symbol: "餌", meaning: "Food, Bait, Prey" },
    { symbol: "璽", meaning: "Emperor's Seal" },
    { symbol: "鹿", meaning: "Deer" },
    { symbol: "式", meaning: "Style, Ceremony, Rite" },
    { symbol: "識", meaning: "Discriminating, Know, Write" },
    { symbol: "軸", meaning: "Axis, Pivot, Stem" },
    { symbol: "七", meaning: "Seven" },
    { symbol: "𠮟", meaning: "Scold, Shout At" },
    { symbol: "失", meaning: "Lose, Error, Fault" },
    { symbol: "室", meaning: "Room, Apartment, Chamber" },
    { symbol: "疾", meaning: "Rapidly" },
    { symbol: "執", meaning: "Tenacious, Take Hold, Grasp" },
    { symbol: "湿", meaning: "Damp, Wet, Moist" },
    { symbol: "嫉", meaning: "Jealous, Envy" },
    { symbol: "漆", meaning: "Lacquer, Varnish, Seven" },
    { symbol: "質", meaning: "Substance, Quality, Matter" },
    { symbol: "実", meaning: "Reality, Truth" },
    { symbol: "芝", meaning: "Turf, Lawn" },
    { symbol: "写", meaning: "Copy, Be Photographed, Describe" },
    { symbol: "社", meaning: "Company, Firm, Office" },
    { symbol: "車", meaning: "Car" },
    { symbol: "舎", meaning: "Cottage, Inn, Hut" },
    { symbol: "者", meaning: "Someone, Person" },
    { symbol: "射", meaning: "Shoot, Shine Into, Onto" },
    { symbol: "捨", meaning: "Discard, Throw Away, Abandon" },
    { symbol: "赦", meaning: "Pardon, Forgiveness" },
    { symbol: "斜", meaning: "Diagonal, Slanting, Oblique" },
    { symbol: "煮", meaning: "Boil, Cook" },
    { symbol: "遮", meaning: "Intercept, Interrupt, Obstruct" },
    { symbol: "謝", meaning: "Apologize, Thank, Refuse" },
    { symbol: "邪", meaning: "Wicked, Injustice, Wrong" },
    { symbol: "蛇", meaning: "Snake, Serpent, Hard Drinker" },
    { symbol: "尺", meaning: "Shaku, Japanese Foot, Measure" },
    { symbol: "借", meaning: "Borrow, Rent" },
    { symbol: "酌", meaning: "Bar-tending, Serving Sake, The Host" },
    { symbol: "釈", meaning: "Explanation" },
    { symbol: "爵", meaning: "Baron, Peerage, Court Rank" },
    { symbol: "若", meaning: "Young, If, Perhaps" },
    { symbol: "弱", meaning: "Weak, Frail" },
    { symbol: "寂", meaning: "Loneliness, Quietly, Mellow" },
    { symbol: "手", meaning: "Hand" },
    { symbol: "主", meaning: "Lord, Chief, Master" },
    { symbol: "守", meaning: "Guard, Protect, Defend" },
    { symbol: "朱", meaning: "Vermilion, Cinnabar, Scarlet" },
    { symbol: "取", meaning: "Take, Fetch, Take Up" },
    { symbol: "狩", meaning: "Hunt, Raid, Gather" },
    { symbol: "首", meaning: "Neck, Counter For Songs And Poems" },
    { symbol: "殊", meaning: "Particularly, Especially, Exceptionally" },
    { symbol: "珠", meaning: "Pearl, Gem, Jewel" },
    { symbol: "酒", meaning: "Sake, Alcohol" },
    { symbol: "腫", meaning: "Tumor, Swelling" },
    { symbol: "種", meaning: "Species, Kind, Class" },
    { symbol: "趣", meaning: "Purport, Gist, Elegance" },
    { symbol: "寿", meaning: "Longevity, Congratulations, One's Natural Life" },
    { symbol: "受", meaning: "Accept, Undergo, Answer (phone)" },
    { symbol: "呪", meaning: "Spell, Curse, Charm" },
    { symbol: "授", meaning: "Impart, Instruct, Grant" },
    { symbol: "需", meaning: "Demand, Request, Need" },
    { symbol: "儒", meaning: "Confucian" },
    { symbol: "樹", meaning: "Timber, Trees, Wood" },
    { symbol: "収", meaning: "Income, Obtain, Reap" },
    { symbol: "囚", meaning: "Captured, Criminal, Arrest" },
    { symbol: "州", meaning: "State, Province" },
    { symbol: "舟", meaning: "Boat, Ship" },
    { symbol: "秀", meaning: "Excel, Excellence, Beauty" },
    { symbol: "周", meaning: "Circumference, Circuit, Lap" },
    { symbol: "宗", meaning: "Religion, Sect, Denomination" },
    { symbol: "拾", meaning: "Pick Up, Gather, Find" },
    { symbol: "秋", meaning: "Autumn" },
    { symbol: "臭", meaning: "Stinking, Ill-smelling, Suspicious Looking" },
    { symbol: "修", meaning: "Discipline, Conduct Oneself Well, Study" },
    { symbol: "袖", meaning: "Sleeve, Wing (building), Extension" },
    { symbol: "終", meaning: "End, Finish" },
    { symbol: "羞", meaning: "Feel Ashamed" },
    { symbol: "習", meaning: "Learn" },
    { symbol: "週", meaning: "Week" },
    { symbol: "就", meaning: "Concerning, Settle, Take Position" },
    { symbol: "衆", meaning: "Masses, Great Numbers, Multitude" },
    { symbol: "集", meaning: "Gather, Meet, Congregate" },
    { symbol: "愁", meaning: "Distress, Grieve, Lament" },
    { symbol: "酬", meaning: "Repay, Reward, Retribution" },
    { symbol: "醜", meaning: "Ugly, Unclean, Shame" },
    { symbol: "蹴", meaning: "Kick" },
    { symbol: "襲", meaning: "Attack, Advance On, Succeed To" },
    { symbol: "十", meaning: "Ten" },
    { symbol: "汁", meaning: "Soup, Juice, Broth" },
    { symbol: "充", meaning: "Allot, Fill" },
    { symbol: "住", meaning: "Dwell, Reside, Live" },
    { symbol: "柔", meaning: "Tender, Weakness, Gentleness" },
    { symbol: "重", meaning: "Heavy, Important, Esteem" },
    { symbol: "従", meaning: "Accompany, Obey, Submit To" },
    { symbol: "渋", meaning: "Astringent, Hesitate, Reluctant" },
    { symbol: "銃", meaning: "Gun, Arms" },
    { symbol: "獣", meaning: "Animal, Beast" },
    { symbol: "縦", meaning: "Vertical, Length, Height" },
    { symbol: "叔", meaning: "Uncle, Youth" },
    { symbol: "祝", meaning: "Celebrate, Congratulate" },
    { symbol: "宿", meaning: "Inn, Lodging, Relay Station" },
    { symbol: "淑", meaning: "Graceful, Gentle, Pure" },
    { symbol: "粛", meaning: "Solemn, Quietly, Softly" },
    { symbol: "縮", meaning: "Shrink, Contract, Shrivel" },
    { symbol: "塾", meaning: "Cram School, Private School" },
    { symbol: "熟", meaning: "Mellow, Ripen, Mature" },
    { symbol: "出", meaning: "Exit, Leave, Go Out" },
    { symbol: "述", meaning: "Mention, State, Speak" },
    { symbol: "術", meaning: "Art, Technique, Skill" },
    { symbol: "俊", meaning: "Sagacious, Genius, Excellence" },
    { symbol: "春", meaning: "Springtime, Spring (season)" },
    { symbol: "瞬", meaning: "Wink, Blink, Twinkle" },
    { symbol: "旬", meaning: "Decameron, Ten-day Period, Season (for Specific Products)" },
    { symbol: "巡", meaning: "Patrol, Go Around, Circumference" },
    { symbol: "盾", meaning: "Shield, Escutcheon, Pretext" },
    { symbol: "准", meaning: "Quasi-, Semi-, Associate" },
    { symbol: "殉", meaning: "Martyrdom, Follow By Resigning" },
    { symbol: "純", meaning: "Genuine, Purity, Innocence" },
    { symbol: "循", meaning: "Sequential, Follow" },
    { symbol: "順", meaning: "Obey, Order, Turn" },
    { symbol: "準", meaning: "Semi-, Correspond To, Proportionate To" },
    { symbol: "潤", meaning: "Wet, Be Watered, Profit By" },
    { symbol: "遵", meaning: "Abide By, Follow, Obey" },
    { symbol: "処", meaning: "Dispose, Manage, Deal With" },
    { symbol: "初", meaning: "First Time, Beginning" },
    { symbol: "所", meaning: "Place, Extent" },
    { symbol: "書", meaning: "Write" },
    { symbol: "庶", meaning: "Commoner, All, Bastard" },
    { symbol: "暑", meaning: "Sultry, Hot, Summer Heat" },
    { symbol: "署", meaning: "Signature, Govt Office, Police Station" },
    { symbol: "緒", meaning: "Thong, Beginning, Inception" },
    { symbol: "諸", meaning: "Various, Many, Several" },
    { symbol: "女", meaning: "Woman, Female" },
    { symbol: "如", meaning: "Likeness, Like, Such As" },
    { symbol: "助", meaning: "Help, Rescue, Assist" },
    { symbol: "序", meaning: "Preface, Beginning, Order" },
    { symbol: "叙", meaning: "Confer, Relate, Narrate" },
    { symbol: "徐", meaning: "Gradually, Slowly, Deliberately" },
    { symbol: "除", meaning: "Exclude, Division (x/3), Remove" },
    { symbol: "小", meaning: "Little, Small" },
    { symbol: "升", meaning: "Measuring Box, 1.8 Liter" },
    { symbol: "少", meaning: "Few, Little" },
    { symbol: "召", meaning: "Seduce, Call, Send For" },
    { symbol: "匠", meaning: "Artisan, Workman, Carpenter" },
    { symbol: "床", meaning: "Bed, Counter For Beds, Floor" },
    { symbol: "抄", meaning: "Extract, Selection, Summary" },
    { symbol: "肖", meaning: "Resemblance" },
    { symbol: "尚", meaning: "Esteem, Furthermore, Still" },
    { symbol: "招", meaning: "Beckon, Invite, Summon" },
    { symbol: "承", meaning: "Acquiesce, Hear, Listen To" },
    { symbol: "昇", meaning: "Rise Up" },
    { symbol: "松", meaning: "Pine Tree" },
    { symbol: "沼", meaning: "Marsh, Lake, Bog" },
    { symbol: "昭", meaning: "Shining, Bright" },
    { symbol: "宵", meaning: "Wee Hours, Evening, Early Night" },
    { symbol: "将", meaning: "Leader, Commander, General" },
    { symbol: "消", meaning: "Extinguish, Blow Out, Turn Off" },
    { symbol: "症", meaning: "Symptoms, Illness" },
    { symbol: "祥", meaning: "Auspicious, Happiness, Blessedness" },
    { symbol: "称", meaning: "Appellation, Praise, Admire" },
    { symbol: "笑", meaning: "Laugh" },
    { symbol: "唱", meaning: "Chant, Recite, Call Upon" },
    { symbol: "商", meaning: "Make A Deal, Selling, Dealing In" },
    { symbol: "渉", meaning: "Ford, Go Cross, Transit" },
    { symbol: "章", meaning: "Badge, Chapter, Composition" },
    { symbol: "紹", meaning: "Introduce, Inherit, Help" },
    { symbol: "訟", meaning: "Sue, Accuse" },
    { symbol: "勝", meaning: "Victory, Win, Prevail" },
    { symbol: "掌", meaning: "Manipulate, Rule, Administer" },
    { symbol: "晶", meaning: "Sparkle, Clear, Crystal" },
    { symbol: "焼", meaning: "Bake, Burning" },
    { symbol: "焦", meaning: "Char, Hurry, Impatient" },
    { symbol: "硝", meaning: "Nitrate, Saltpeter" },
    { symbol: "粧", meaning: "Cosmetics, Adorn (one's Person)" },
    { symbol: "詔", meaning: "Imperial Edict" },
    { symbol: "証", meaning: "Evidence, Proof, Certificate" },
    { symbol: "象", meaning: "Elephant, Pattern After, Imitate" },
    { symbol: "傷", meaning: "Wound, Hurt, Injure" },
    { symbol: "奨", meaning: "Exhort, Urge, Encourage" },
    { symbol: "照", meaning: "Illuminate, Shine, Compare" },
    { symbol: "詳", meaning: "Detailed, Full, Minute" },
    { symbol: "彰", meaning: "Patent, Clear" },
    { symbol: "障", meaning: "Hinder, Hurt, Harm" },
    { symbol: "憧", meaning: "Yearn After, Long For, Aspire To" },
    { symbol: "衝", meaning: "Collide, Brunt, Highway" },
    { symbol: "賞", meaning: "Prize, Reward, Praise" },
    { symbol: "償", meaning: "Reparation, Make Up For, Recompense" },
    { symbol: "礁", meaning: "Reef, Sunken Rock" },
    { symbol: "鐘", meaning: "Bell, Gong, Chimes" },
    { symbol: "上", meaning: "Above, Up" },
    { symbol: "丈", meaning: "Length, Ten Shaku, Measure" },
    { symbol: "冗", meaning: "Superfluous, Uselessness" },
    { symbol: "条", meaning: "Article, Clause, Item" },
    { symbol: "状", meaning: "Status Quo, Conditions, Circumstances" },
    { symbol: "乗", meaning: "Ride, Power, Multiplication" },
    { symbol: "城", meaning: "Castle" },
    { symbol: "浄", meaning: "Clean, Purify, Cleanse" },
    { symbol: "剰", meaning: "Surplus, Besides" },
    { symbol: "常", meaning: "Usual, Ordinary, Normal" },
    { symbol: "情", meaning: "Feelings, Emotion, Passion" },
    { symbol: "場", meaning: "Location, Place" },
    { symbol: "畳", meaning: "Tatami Mat, Counter For Tatami Mats, Fold" },
    { symbol: "蒸", meaning: "Steam, Heat, Sultry" },
    { symbol: "縄", meaning: "Straw Rope, Cord" },
    { symbol: "壌", meaning: "Lot, Earth, Soil" },
    { symbol: "嬢", meaning: "Lass, Girl, Miss" },
    { symbol: "錠", meaning: "Lock, Fetters, Shackles" },
    { symbol: "譲", meaning: "Defer, Turnover, Transfer" },
    { symbol: "醸", meaning: "Brew, Cause" },
    { symbol: "色", meaning: "Color" },
    { symbol: "拭", meaning: "Wipe, Mop, Swab" },
    { symbol: "食", meaning: "Eat, Food" },
    { symbol: "植", meaning: "Plant" },
    { symbol: "殖", meaning: "Augment, Increase, Multiply" },
    { symbol: "飾", meaning: "Decorate, Ornament, Adorn" },
    { symbol: "触", meaning: "Contact, Touch, Feel" },
    { symbol: "嘱", meaning: "Entrust, Request, Send A Message" },
    { symbol: "織", meaning: "Weave, Fabric" },
    { symbol: "職", meaning: "Post, Employment, Work" },
    { symbol: "辱", meaning: "Embarrass, Humiliate, Shame" },
    { symbol: "尻", meaning: "Buttocks, Hips, Butt" },
    { symbol: "心", meaning: "Heart, Mind, Spirit" },
    { symbol: "申", meaning: "Have The Honor To, Sign Of The Monkey, 3-5pm" },
    { symbol: "伸", meaning: "Expand, Stretch, Extend" },
    { symbol: "臣", meaning: "Retainer, Subject" },
    { symbol: "芯", meaning: "Wick" },
    { symbol: "身", meaning: "Somebody, Person, One's Station In Life" },
    { symbol: "辛", meaning: "Spicy, Bitter, Hot" },
    { symbol: "侵", meaning: "Encroach, Invade, Raid" },
    { symbol: "信", meaning: "Faith, Truth, Fidelity" },
    { symbol: "津", meaning: "Haven, Port, Harbor" },
    { symbol: "神", meaning: "Gods, Mind, Soul" },
    { symbol: "唇", meaning: "Lips" },
    { symbol: "娠", meaning: "With Child, Pregnancy" },
    { symbol: "振", meaning: "Shake, Wave, Wag" },
    { symbol: "浸", meaning: "Immersed, Soak, Dip" },
    { symbol: "真", meaning: "True, Reality, Buddhist Sect" },
    { symbol: "針", meaning: "Needle, Pin, Staple" },
    { symbol: "深", meaning: "Deep, Heighten, Intensify" },
    { symbol: "紳", meaning: "Sire, Good Belt, Gentleman" },
    { symbol: "進", meaning: "Advance, Proceed, Progress" },
    { symbol: "森", meaning: "Forest, Woods" },
    { symbol: "診", meaning: "Checkup, Seeing, Diagnose" },
    { symbol: "寝", meaning: "Lie Down, Sleep, Rest" },
    { symbol: "慎", meaning: "Humility, Be Careful, Discreet" },
    { symbol: "新", meaning: "New" },
    { symbol: "審", meaning: "Hearing, Judge, Trial" },
    { symbol: "震", meaning: "Quake, Shake, Tremble" },
    { symbol: "薪", meaning: "Fuel, Firewood, Kindling" },
    { symbol: "親", meaning: "Parent, Intimacy, Relative" },
    { symbol: "人", meaning: "Person" },
    { symbol: "刃", meaning: "Blade, Sword, Edge" },
    { symbol: "仁", meaning: "Humanity, Virtue, Benevolence" },
    { symbol: "尽", meaning: "Exhaust, Use Up, Run Out Of" },
    { symbol: "迅", meaning: "Swift, Fast" },
    { symbol: "甚", meaning: "Tremendously, Very, Great" },
    { symbol: "陣", meaning: "Camp, Battle Array, Ranks" },
    { symbol: "尋", meaning: "Inquire, Fathom, Look For" },
    { symbol: "腎", meaning: "Kidney" },
    { symbol: "須", meaning: "Ought, By All Means, Necessarily" },
    { symbol: "図", meaning: "Map, Drawing, Plan" },
    { symbol: "水", meaning: "Water" },
    { symbol: "吹", meaning: "Blow, Breathe, Puff" },
    { symbol: "垂", meaning: "Droop, Suspend, Hang" },
    { symbol: "炊", meaning: "Cook, Boil" },
    { symbol: "帥", meaning: "Commander, Leading Troops, Governor" },
    { symbol: "粋", meaning: "Chic, Style, Purity" },
    { symbol: "衰", meaning: "Decline, Wane, Weaken" },
    { symbol: "推", meaning: "Conjecture, Infer, Guess" },
    { symbol: "酔", meaning: "Drunk, Feel Sick, Poisoned" },
    { symbol: "遂", meaning: "Consummate, Accomplish, Attain" },
    { symbol: "睡", meaning: "Drowsy, Sleep, Die" },
    { symbol: "穂", meaning: "Ear, Ear (grain), Head" },
    { symbol: "随", meaning: "Follow, Though, Notwithstanding" },
    { symbol: "髄", meaning: "Marrow, Pith, Essence" },
    { symbol: "枢", meaning: "Hinge, Pivot, Door" },
    { symbol: "崇", meaning: "Adore, Respect, Revere" },
    { symbol: "数", meaning: "Number, Strength, Fate" },
    { symbol: "据", meaning: "Set, Lay A Foundation, Install" },
    { symbol: "杉", meaning: "Cedar, Cryptomeria" },
    { symbol: "裾", meaning: "Cuff, Hem, Foot Of Mountain" },
    { symbol: "寸", meaning: "Measurement, Tenth Of A Shaku, A Little" },
    { symbol: "瀬", meaning: "Rapids, Current, Torrent" },
    { symbol: "是", meaning: "Just So, This, Right" },
    { symbol: "井", meaning: "Well, Well Crib, Town" },
    { symbol: "世", meaning: "Generation, World, Society" },
    { symbol: "正", meaning: "Correct, Justice, Righteous" },
    { symbol: "生", meaning: "Life, Genuine, Birth" },
    { symbol: "成", meaning: "Turn Into, Become, Get" },
    { symbol: "西", meaning: "West, Spain" },
    { symbol: "声", meaning: "Voice" },
    { symbol: "制", meaning: "System, Law, Rule" },
    { symbol: "姓", meaning: "Surname" },
    { symbol: "征", meaning: "Subjugate, Attack The Rebellious, Collect Taxes" },
    { symbol: "性", meaning: "Sex, Gender, Nature" },
    { symbol: "青", meaning: "Blue, Green" },
    { symbol: "斉", meaning: "Adjusted, Alike, Equal" },
    { symbol: "政", meaning: "Politics, Government" },
    { symbol: "星", meaning: "Star, Spot, Dot" },
    { symbol: "牲", meaning: "Animal Sacrifice, Offering" },
    { symbol: "省", meaning: "Focus, Government Ministry, Conserve" },
    { symbol: "凄", meaning: "Uncanny, Weird, Threatening" },
    { symbol: "逝", meaning: "Departed, Die" },
    { symbol: "清", meaning: "Pure, Purify, Cleanse" },
    { symbol: "盛", meaning: "Boom, Prosper, Copulate" },
    { symbol: "婿", meaning: "Bridegroom, Son-in-law" },
    { symbol: "晴", meaning: "Clear Up" },
    { symbol: "勢", meaning: "Forces, Energy, Military Strength" },
    { symbol: "聖", meaning: "Holy, Saint, Sage" },
    { symbol: "誠", meaning: "Sincerity, Admonish, Warn" },
    { symbol: "精", meaning: "Refined, Ghost, Fairy" },
    { symbol: "製", meaning: "Made In..., Manufacture" },
    { symbol: "誓", meaning: "Vow, Swear, Pledge" },
    { symbol: "静", meaning: "Quiet" },
    { symbol: "請", meaning: "Solicit, Invite, Ask" },
    { symbol: "整", meaning: "Organize, Arranging, Tune" },
    { symbol: "醒", meaning: "Awake, Be Disillusioned, Sober Up" },
    { symbol: "税", meaning: "Tax, Duty" },
    { symbol: "夕", meaning: "Evening" },
    { symbol: "斥", meaning: "Reject, Retreat, Recede" },
    { symbol: "石", meaning: "Stone" },
    { symbol: "赤", meaning: "Red" },
    { symbol: "昔", meaning: "Once Upon A Time, Antiquity, Old Times" },
    { symbol: "析", meaning: "Chop, Divide, Tear" },
    { symbol: "席", meaning: "Seat, Mat, Occasion" },
    { symbol: "脊", meaning: "Stature, Height" },
    { symbol: "隻", meaning: "Vessels, Counter For Ships, Fish" },
    { symbol: "惜", meaning: "Pity, Be Sparing Of, Frugal" },
    { symbol: "戚", meaning: "Grieve, Relatives" },
    { symbol: "責", meaning: "Blame, Condemn, Censure" },
    { symbol: "跡", meaning: "Tracks, Mark, Print" },
    { symbol: "積", meaning: "Volume, Product (x*y), Acreage" },
    { symbol: "績", meaning: "Exploits, Achievements, Unreeling Cocoons" },
    { symbol: "籍", meaning: "Enroll, Domiciliary Register, Membership" },
    { symbol: "切", meaning: "Cut, Cutoff, Be Sharp" },
    { symbol: "折", meaning: "Fold, Break, Fracture" },
    { symbol: "拙", meaning: "Bungling, Clumsy, Unskillful" },
    { symbol: "窃", meaning: "Stealth, Steal, Secret" },
    { symbol: "接", meaning: "Touch, Contact, Adjoin" },
    { symbol: "設", meaning: "Establishment, Provision, Prepare" },
    { symbol: "雪", meaning: "Snow" },
    { symbol: "摂", meaning: "Vicarious, Surrogate, Act In Addition To" },
    { symbol: "節", meaning: "Node, Season, Period" },
    { symbol: "説", meaning: "Opinion, Theory, Explanation" },
    { symbol: "舌", meaning: "Tongue, Reed, Clapper" },
    { symbol: "絶", meaning: "Discontinue, Sever, Cut Off" },
    { symbol: "千", meaning: "Thousand" },
    { symbol: "川", meaning: "Stream, River" },
    { symbol: "仙", meaning: "Hermit, Wizard, Cent" },
    { symbol: "占", meaning: "Fortune-telling, Divining, Forecasting" },
    { symbol: "先", meaning: "Before, Ahead, Previous" },
    { symbol: "宣", meaning: "Proclaim, Say, Announce" },
    { symbol: "専", meaning: "Specialty, Exclusive, Mainly" },
    { symbol: "泉", meaning: "Spring, Fountain" },
    { symbol: "浅", meaning: "Shallow, Superficial, Frivolous" },
    { symbol: "洗", meaning: "Wash, Inquire Into, Probe" },
    { symbol: "染", meaning: "Dye, Color, Paint" },
    { symbol: "扇", meaning: "Fan, Folding Fan" },
    { symbol: "栓", meaning: "Plug, Bolt, Cork" },
    { symbol: "旋", meaning: "Rotation, Go Around" },
    { symbol: "船", meaning: "Ship, Boat" },
    { symbol: "戦", meaning: "War, Battle, Match" },
    { symbol: "煎", meaning: "Broil, Parch, Roast" },
    { symbol: "羨", meaning: "Envious, Be Jealous, Covet" },
    { symbol: "腺", meaning: "Gland" },
    { symbol: "詮", meaning: "Discussion, Methods Called For, Selection" },
    { symbol: "践", meaning: "Tread, Step On, Trample" },
    { symbol: "箋", meaning: "Paper, Label, Letter" },
    { symbol: "銭", meaning: "Coin, .01 Yen, Money" },
    { symbol: "潜", meaning: "Submerge, Conceal, Hide" },
    { symbol: "線", meaning: "Line, Track" },
    { symbol: "遷", meaning: "Transition, Move, Change" },
    { symbol: "選", meaning: "Elect, Select, Choose" },
    { symbol: "薦", meaning: "Recommend, Mat, Advise" },
    { symbol: "繊", meaning: "Slender, Fine, Thin Kimono" },
    { symbol: "鮮", meaning: "Fresh, Vivid, Clear" },
    { symbol: "全", meaning: "Whole, Entire, All" },
    { symbol: "前", meaning: "In Front, Before" },
    { symbol: "善", meaning: "Virtuous, Good, Goodness" },
    { symbol: "然", meaning: "Sort Of Thing, So, If So" },
    { symbol: "禅", meaning: "Zen, Silent Meditation" },
    { symbol: "漸", meaning: "Steadily, Gradually Advancing, Finally" },
    { symbol: "膳", meaning: "Small Low Table, Tray" },
    { symbol: "繕", meaning: "Darning, Repair, Mend" },
    { symbol: "狙", meaning: "Aim At, Sight, Shadow" },
    { symbol: "阻", meaning: "Thwart, Separate From, Prevent" },
    { symbol: "祖", meaning: "Ancestor, Pioneer, Founder" },
    { symbol: "租", meaning: "Tariff, Crop Tax, Borrowing" },
    { symbol: "素", meaning: "Elementary, Principle, Naked" },
    { symbol: "措", meaning: "Set Aside, Give Up, Suspend" },
    { symbol: "粗", meaning: "Coarse, Rough, Rugged" },
    { symbol: "組", meaning: "Association, Braid, Plait" },
    { symbol: "疎", meaning: "Alienate, Rough, Neglect" },
    { symbol: "訴", meaning: "Accusation, Sue, Complain Of Pain" },
    { symbol: "塑", meaning: "Model, Molding" },
    { symbol: "遡", meaning: "Go Upstream, Retrace The Past" },
    { symbol: "礎", meaning: "Cornerstone, Foundation Stone" },
    { symbol: "双", meaning: "Pair, Set, Comparison" },
    { symbol: "壮", meaning: "Robust, Manhood, Prosperity" },
    { symbol: "早", meaning: "Early, Fast" },
    { symbol: "争", meaning: "Contend, Dispute, Argue" },
    { symbol: "走", meaning: "Run" },
    { symbol: "奏", meaning: "Play Music, Speak To A Ruler, Complete" },
    { symbol: "相", meaning: "Inter-, Mutual, Together" },
    { symbol: "荘", meaning: "Villa, Inn, Cottage" },
    { symbol: "草", meaning: "Grass, Weeds, Herbs" },
    { symbol: "送", meaning: "Escort, Send" },
    { symbol: "倉", meaning: "Godown, Warehouse, Storehouse" },
    { symbol: "捜", meaning: "Search, Look For, Locate" },
    { symbol: "挿", meaning: "Insert, Put In, Graft" },
    { symbol: "桑", meaning: "Mulberry" },
    { symbol: "巣", meaning: "Nest, Rookery, Hive" },
    { symbol: "掃", meaning: "Sweep, Brush" },
    { symbol: "曹", meaning: "Office, Official, Comrade" },
    { symbol: "曽", meaning: "Formerly, Once, Before" },
    { symbol: "爽", meaning: "Refreshing, Bracing, Resonant" },
    { symbol: "窓", meaning: "Window, Pane" },
    { symbol: "創", meaning: "Genesis, Wound, Injury" },
    { symbol: "喪", meaning: "Miss, Mourning" },
    { symbol: "痩", meaning: "Get Thin" },
    { symbol: "葬", meaning: "Interment, Bury, Shelve" },
    { symbol: "装", meaning: "Attire, Dress, Pretend" },
    { symbol: "僧", meaning: "Buddhist Priest, Monk" },
    { symbol: "想", meaning: "Concept, Think, Idea" },
    { symbol: "層", meaning: "Stratum, Social Class, Layer" },
    { symbol: "総", meaning: "General, Whole, All" },
    { symbol: "遭", meaning: "Encounter, Meet, Party" },
    { symbol: "槽", meaning: "Vat, Tub, Tank" },
    { symbol: "踪", meaning: "Remains, Clue, Footprint" },
    { symbol: "操", meaning: "Maneuver, Manipulate, Operate" },
    { symbol: "燥", meaning: "Parch, Dry Up" },
    { symbol: "霜", meaning: "Frost" },
    { symbol: "騒", meaning: "Boisterous, Make Noise, Clamor" },
    { symbol: "藻", meaning: "Seaweed, Duckweed" },
    { symbol: "造", meaning: "Create, Make, Structure" },
    { symbol: "像", meaning: "Statue, Picture, Image" },
    { symbol: "増", meaning: "Increase, Add, Augment" },
    { symbol: "憎", meaning: "Hate, Detest" },
    { symbol: "蔵", meaning: "Storehouse, Hide, Own" },
    { symbol: "贈", meaning: "Presents, Send, Give To" },
    { symbol: "臓", meaning: "Entrails, Viscera, Bowels" },
    { symbol: "即", meaning: "Instant, Namely, As Is" },
    { symbol: "束", meaning: "Bundle, Sheaf, Ream" },
    { symbol: "足", meaning: "Leg, Foot, Be Sufficient" },
    { symbol: "促", meaning: "Stimulate, Urge, Press" },
    { symbol: "則", meaning: "Rule, Follow, Based On" },
    { symbol: "息", meaning: "Breath, Respiration, Son" },
    { symbol: "捉", meaning: "Catch, Capture" },
    { symbol: "速", meaning: "Quick, Fast" },
    { symbol: "側", meaning: "Side, Lean, Oppose" },
    { symbol: "測", meaning: "Fathom, Plan, Scheme" },
    { symbol: "俗", meaning: "Vulgar, Customs, Manners" },
    { symbol: "族", meaning: "Tribe, Family" },
    { symbol: "属", meaning: "Belong, Genus, Subordinate Official" },
    { symbol: "賊", meaning: "Burglar, Rebel, Traitor" },
    { symbol: "続", meaning: "Continue, Series, Sequel" },
    { symbol: "卒", meaning: "Graduate, Soldier, Private" },
    { symbol: "率", meaning: "Ratio, Rate, Proportion" },
    { symbol: "存", meaning: "Exist, Suppose, Be Aware Of" },
    { symbol: "村", meaning: "Village, Town" },
    { symbol: "孫", meaning: "Grandchild, Descendants" },
    { symbol: "尊", meaning: "Revered, Valuable, Precious" },
    { symbol: "損", meaning: "Damage, Loss, Disadvantage" },
    { symbol: "遜", meaning: "Humble, Modest" },
    { symbol: "他", meaning: "Other, Another, The Others" },
    { symbol: "多", meaning: "Many, Frequent, Much" },
    { symbol: "汰", meaning: "Washing, Sieving, Filtering" },
    { symbol: "打", meaning: "Strike, Hit, Knock" },
    { symbol: "妥", meaning: "Gentle, Peace, Depravity" },
    { symbol: "唾", meaning: "Saliva, Sputum" },
    { symbol: "堕", meaning: "Degenerate, Descend To, Lapse Into" },
    { symbol: "惰", meaning: "Lazy, Laziness" },
    { symbol: "駄", meaning: "Burdensome, Pack Horse, Horse Load" },
    { symbol: "太", meaning: "Plump, Thick, Big Around" },
    { symbol: "対", meaning: "Vis-a-vis, Opposite, Even" },
    { symbol: "体", meaning: "Body, Substance, Object" },
    { symbol: "耐", meaning: "-proof, Enduring" },
    { symbol: "待", meaning: "Wait, Depend On" },
    { symbol: "怠", meaning: "Neglect, Laziness" },
    { symbol: "胎", meaning: "Womb, Uterus" },
    { symbol: "退", meaning: "Retreat, Withdraw, Retire" },
    { symbol: "帯", meaning: "Sash, Belt, Obi" },
    { symbol: "泰", meaning: "Peaceful, Calm, Peace" },
    { symbol: "堆", meaning: "Piled High" },
    { symbol: "袋", meaning: "Sack, Bag, Pouch" },
    { symbol: "逮", meaning: "Apprehend, Chase" },
    { symbol: "替", meaning: "Exchange, Spare, Substitute" },
    { symbol: "貸", meaning: "Lend" },
    { symbol: "隊", meaning: "Regiment, Party, Company" },
    { symbol: "滞", meaning: "Stagnate, Be Delayed, Overdue" },
    { symbol: "態", meaning: "Attitude, Condition, Figure" },
    { symbol: "戴", meaning: "Be Crowned With, Live Under (a Ruler), Receive" },
    { symbol: "大", meaning: "Large, Big" },
    { symbol: "代", meaning: "Substitute, Change, Convert" },
    { symbol: "台", meaning: "Pedestal, A Stand, Counter For Machines And Vehicles" },
    { symbol: "第", meaning: "No., Residence" },
    { symbol: "題", meaning: "Topic, Subject" },
    { symbol: "滝", meaning: "Waterfall, Rapids, Cascade" },
    { symbol: "宅", meaning: "Home, House, Residence" },
    { symbol: "択", meaning: "Choose, Select, Elect" },
    { symbol: "沢", meaning: "Swamp, Marsh, Brilliance" },
    { symbol: "卓", meaning: "Eminent, Table, Desk" },
    { symbol: "拓", meaning: "Clear (the Land), Open, Break Up (land)" },
    { symbol: "託", meaning: "Consign, Requesting, Entrusting With" },
    { symbol: "濯", meaning: "Laundry, Wash, Pour On" },
    { symbol: "諾", meaning: "Consent, Assent, Agreement" },
    { symbol: "濁", meaning: "Voiced, Uncleanness, Wrong" },
    { symbol: "但", meaning: "However, But" },
    { symbol: "達", meaning: "Accomplished, Reach, Arrive" },
    { symbol: "脱", meaning: "Undress, Removing, Escape From" },
    { symbol: "奪", meaning: "Rob, Take By Force, Snatch Away" },
    { symbol: "棚", meaning: "Shelf, Ledge, Rack" },
    { symbol: "誰", meaning: "Who, Someone, Somebody" },
    { symbol: "丹", meaning: "Rust-colored, Red, Red Lead" },
    { symbol: "旦", meaning: "Daybreak, Dawn, Morning" },
    { symbol: "担", meaning: "Shouldering, Carry, Raise" },
    { symbol: "単", meaning: "Simple, One, Single" },
    { symbol: "炭", meaning: "Charcoal, Coal" },
    { symbol: "胆", meaning: "Gall Bladder, Courage, Pluck" },
    { symbol: "探", meaning: "Grope, Search, Look For" },
    { symbol: "淡", meaning: "Thin, Faint, Pale" },
    { symbol: "短", meaning: "Short, Brevity, Fault" },
    { symbol: "嘆", meaning: "Sigh, Lament, Moan" },
    { symbol: "端", meaning: "Edge, Origin, End" },
    { symbol: "綻", meaning: "Be Rent, Ripped, Unravel" },
    { symbol: "誕", meaning: "Nativity, Be Born, Declension" },
    { symbol: "鍛", meaning: "Forge, Discipline, Train" },
    { symbol: "団", meaning: "Group, Association" },
    { symbol: "男", meaning: "Male" },
    { symbol: "段", meaning: "Grade, Steps, Stairs" },
    { symbol: "断", meaning: "Severance, Decline, Refuse" },
    { symbol: "弾", meaning: "Bullet, Twang, Flip" },
    { symbol: "暖", meaning: "Warmth" },
    { symbol: "談", meaning: "Discuss, Talk" },
    { symbol: "壇", meaning: "Podium, Stage, Rostrum" },
    { symbol: "地", meaning: "Ground, Earth" },
    { symbol: "池", meaning: "Pond, Cistern, Pool" },
    { symbol: "知", meaning: "Know, Wisdom" },
    { symbol: "値", meaning: "Price, Cost, Value" },
    { symbol: "恥", meaning: "Shame, Dishonor" },
    { symbol: "致", meaning: "Doth, Do, Send" },
    { symbol: "遅", meaning: "Slow, Late, Back" },
    { symbol: "痴", meaning: "Stupid, Foolish" },
    { symbol: "稚", meaning: "Immature, Young" },
    { symbol: "置", meaning: "Placement, Put, Set" },
    { symbol: "緻", meaning: "Fine (i.e. Not Coarse)" },
    { symbol: "竹", meaning: "Bamboo" },
    { symbol: "畜", meaning: "Livestock, Domestic Fowl And Animals" },
    { symbol: "逐", meaning: "Pursue, Drive Away, Chase" },
    { symbol: "蓄", meaning: "Amass, Raise, Hoard" },
    { symbol: "築", meaning: "Fabricate, Build, Construct" },
    { symbol: "秩", meaning: "Regularity, Salary, Order" },
    { symbol: "窒", meaning: "Plug Up, Obstruct" },
    { symbol: "茶", meaning: "Tea" },
    { symbol: "着", meaning: "Don, Arrive, Wear" },
    { symbol: "嫡", meaning: "Legitimate Wife, Direct Descent (non-bastard)" },
    { symbol: "中", meaning: "In, Inside, Middle" },
    { symbol: "仲", meaning: "Go-between, Relationship" },
    { symbol: "虫", meaning: "Insect, Bug, Temper" },
    { symbol: "沖", meaning: "Open Sea, Offing, Rise High Into Sky" },
    { symbol: "宙", meaning: "Mid-air, Air, Space" },
    { symbol: "忠", meaning: "Loyalty, Fidelity, Faithfulness" },
    { symbol: "抽", meaning: "Pluck, Pull, Extract" },
    { symbol: "注", meaning: "Pour, Irrigate, Shed (tears)" },
    { symbol: "昼", meaning: "Daytime, Noon" },
    { symbol: "柱", meaning: "Pillar, Post, Cylinder" },
    { symbol: "衷", meaning: "Inmost, Heart, Mind" },
    { symbol: "酎", meaning: "Sake" },
    { symbol: "鋳", meaning: "Casting, Mint" },
    { symbol: "駐", meaning: "Stop-over, Reside In, Resident" },
    { symbol: "著", meaning: "Renowned, Publish, Write" },
    { symbol: "貯", meaning: "Savings, Store, Lay In" },
    { symbol: "丁", meaning: "Street, Ward, Town" },
    { symbol: "弔", meaning: "Condolences, Mourning, Funeral" },
    { symbol: "庁", meaning: "Government Office" },
    { symbol: "兆", meaning: "Portent, 10**12, Trillion" },
    { symbol: "町", meaning: "Town, Village, Block" },
    { symbol: "長", meaning: "Long, Leader, Superior" },
    { symbol: "挑", meaning: "Challenge, Contend For, Make Love To" },
    { symbol: "帳", meaning: "Notebook, Account Book, Album" },
    { symbol: "張", meaning: "Lengthen, Counter For Bows & Stringed Instruments, Stretch" },
    { symbol: "彫", meaning: "Carve, Engrave, Chisel" },
    { symbol: "眺", meaning: "Stare, Watch, Look At" },
    { symbol: "釣", meaning: "Angling, Fish, Catch" },
    { symbol: "頂", meaning: "Place On The Head, Receive, Top Of Head" },
    { symbol: "鳥", meaning: "Bird, Chicken" },
    { symbol: "朝", meaning: "Morning, Dynasty, Regime" },
    { symbol: "貼", meaning: "Stick, Paste, Apply" },
    { symbol: "超", meaning: "Transcend, Super-, Ultra-" },
    { symbol: "腸", meaning: "Intestines, Guts, Bowels" },
    { symbol: "跳", meaning: "Hop, Leap Up, Spring" },
    { symbol: "徴", meaning: "Indications, Sign, Omen" },
    { symbol: "嘲", meaning: "Ridicule, Insult" },
    { symbol: "潮", meaning: "Tide, Salt Water, Opportunity" },
    { symbol: "澄", meaning: "Lucidity, Be Clear, Clear" },
    { symbol: "調", meaning: "Tune, Tone, Meter" },
    { symbol: "聴", meaning: "Listen, Headstrong, Naughty" },
    { symbol: "懲", meaning: "Penal, Chastise, Punish" },
    { symbol: "直", meaning: "Straightaway, Honesty, Frankness" },
    { symbol: "勅", meaning: "Imperial Order" },
    { symbol: "捗", meaning: "Make Progress" },
    { symbol: "沈", meaning: "Sink, Be Submerged, Subside" },
    { symbol: "珍", meaning: "Rare, Curious, Strange" },
    { symbol: "朕", meaning: "Majestic Plural, Imperial We" },
    { symbol: "陳", meaning: "Exhibit, State, Relate" },
    { symbol: "賃", meaning: "Fare, Fee, Hire" },
    { symbol: "鎮", meaning: "Tranquilize, Ancient Peace-preservation Centers" },
    { symbol: "追", meaning: "Chase, Drive Away, Follow" },
    { symbol: "椎", meaning: "Chinquapin, Mallet, Spine" },
    { symbol: "墜", meaning: "Crash, Fall (down)" },
    { symbol: "通", meaning: "Traffic, Pass Through, Avenue" },
    { symbol: "痛", meaning: "Pain, Hurt, Damage" },
    { symbol: "塚", meaning: "Hillock, Mound" },
    { symbol: "漬", meaning: "Pickling, Soak, Moisten" },
    { symbol: "坪", meaning: "Two-mat Area, Approx. Thirty-six Sq Ft" },
    { symbol: "爪", meaning: "Claw, Nail, Talon" },
    { symbol: "鶴", meaning: "Crane, Stork" },
    { symbol: "低", meaning: "Lower, Short, Humble" },
    { symbol: "呈", meaning: "Display, Offer, Present" },
    { symbol: "廷", meaning: "Courts, Imperial Court, Government Office" },
    { symbol: "弟", meaning: "Younger Brother, Faithful Service To Elders" },
    { symbol: "定", meaning: "Determine, Fix, Establish" },
    { symbol: "底", meaning: "Bottom, Sole, Depth" },
    { symbol: "抵", meaning: "Resist, Reach, Touch" },
    { symbol: "邸", meaning: "Residence, Mansion" },
    { symbol: "亭", meaning: "Pavilion, Restaurant, Mansion" },
    { symbol: "貞", meaning: "Upright, Chastity, Constancy" },
    { symbol: "帝", meaning: "Sovereign, The Emperor, God" },
    { symbol: "訂", meaning: "Revise, Correct, Decide" },
    { symbol: "庭", meaning: "Courtyard, Garden, Yard" },
    { symbol: "逓", meaning: "Relay, In Turn, Sending" },
    { symbol: "停", meaning: "Halt, Stopping" },
    { symbol: "偵", meaning: "Spy" },
    { symbol: "堤", meaning: "Dike, Bank, Embankment" },
    { symbol: "提", meaning: "Propose, Take Along, Carry In Hand" },
    { symbol: "程", meaning: "Extent, Degree, Law" },
    { symbol: "艇", meaning: "Rowboat, Small Boat" },
    { symbol: "締", meaning: "Tighten, Tie, Shut" },
    { symbol: "諦", meaning: "Truth, Clarity, Abandon" },
    { symbol: "泥", meaning: "Mud, Mire, Adhere To" },
    { symbol: "的", meaning: "Bull's Eye, Mark, Target" },
    { symbol: "笛", meaning: "Flute, Clarinet, Pipe" },
    { symbol: "摘", meaning: "Pinch, Pick, Pluck" },
    { symbol: "滴", meaning: "Drip, Drop" },
    { symbol: "適", meaning: "Suitable, Occasional, Rare" },
    { symbol: "敵", meaning: "Enemy, Foe, Opponent" },
    { symbol: "溺", meaning: "Drown, Indulge" },
    { symbol: "迭", meaning: "Transfer, Alternation" },
    { symbol: "哲", meaning: "Philosophy, Clear" },
    { symbol: "鉄", meaning: "Iron" },
    { symbol: "徹", meaning: "Penetrate, Clear, Pierce" },
    { symbol: "撤", meaning: "Remove, Withdraw, Disarm" },
    { symbol: "天", meaning: "Heavens, Sky, Imperial" },
    { symbol: "典", meaning: "Code, Ceremony, Law" },
    { symbol: "店", meaning: "Store, Shop" },
    { symbol: "点", meaning: "Spot, Point, Mark" },
    { symbol: "展", meaning: "Unfold, Expand" },
    { symbol: "添", meaning: "Annexed, Accompany, Marry" },
    { symbol: "転", meaning: "Revolve, Turn Around, Change" },
    { symbol: "塡", meaning: "Fill In, Fill Up, Make Good" },
    { symbol: "田", meaning: "Rice Field, Rice Paddy" },
    { symbol: "伝", meaning: "Transmit, Go Along, Walk Along" },
    { symbol: "殿", meaning: "Mr., Hall, Mansion" },
    { symbol: "電", meaning: "Electricity" },
    { symbol: "斗", meaning: "Big Dipper, Ten Sho (vol), Sake Dipper" },
    { symbol: "吐", meaning: "Spit, Vomit, Belch" },
    { symbol: "妬", meaning: "Jealous, Envy" },
    { symbol: "徒", meaning: "On Foot, Junior, Emptiness" },
    { symbol: "途", meaning: "Route, Way, Road" },
    { symbol: "都", meaning: "Metropolis, Capital, All" },
    { symbol: "渡", meaning: "Transit, Ford, Ferry" },
    { symbol: "塗", meaning: "Paint, Plaster, Daub" },
    { symbol: "賭", meaning: "Gamble, Wager, Bet" },
    { symbol: "土", meaning: "Soil, Earth, Ground" },
    { symbol: "奴", meaning: "Guy, Slave, Manservant" },
    { symbol: "努", meaning: "Toil, Diligent, As Much As Possible" },
    { symbol: "度", meaning: "Degrees, Occurrence, Time" },
    { symbol: "怒", meaning: "Angry, Be Offended" },
    { symbol: "刀", meaning: "Sword, Saber, Knife" },
    { symbol: "冬", meaning: "Winter" },
    { symbol: "灯", meaning: "Lamp, A Light, Light" },
    { symbol: "当", meaning: "Hit, Right, Appropriate" },
    { symbol: "投", meaning: "Throw, Discard, Abandon" },
    { symbol: "豆", meaning: "Beans, Pea, Midget" },
    { symbol: "東", meaning: "East" },
    { symbol: "到", meaning: "Arrival, Proceed, Reach" },
    { symbol: "逃", meaning: "Escape, Flee, Shirk" },
    { symbol: "倒", meaning: "Overthrow, Fall, Collapse" },
    { symbol: "凍", meaning: "Frozen, Congeal, Refrigerate" },
    { symbol: "唐", meaning: "T'ang, China, Foreign" },
    { symbol: "島", meaning: "Island" },
    { symbol: "桃", meaning: "Peach" },
    { symbol: "討", meaning: "Chastise, Attack, Defeat" },
    { symbol: "透", meaning: "Transparent, Permeate, Filter" },
    { symbol: "党", meaning: "Party, Faction, Clique" },
    { symbol: "悼", meaning: "Lament, Grieve Over" },
    { symbol: "盗", meaning: "Steal, Rob, Pilfer" },
    { symbol: "陶", meaning: "Pottery, Porcelain" },
    { symbol: "塔", meaning: "Pagoda, Tower, Steeple" },
    { symbol: "搭", meaning: "Board, Load (a Vehicle), Ride" },
    { symbol: "棟", meaning: "Ridgepole, Ridge" },
    { symbol: "湯", meaning: "Hot Water, Bath, Hot Spring" },
    { symbol: "痘", meaning: "Pox, Smallpox" },
    { symbol: "登", meaning: "Ascend, Climb Up" },
    { symbol: "答", meaning: "Solution, Answer" },
    { symbol: "等", meaning: "Etc., And So Forth, Class (first)" },
    { symbol: "筒", meaning: "Cylinder, Pipe, Tube" },
    { symbol: "統", meaning: "Overall, Relationship, Ruling" },
    { symbol: "稲", meaning: "Rice Plant" },
    { symbol: "踏", meaning: "Step, Trample, Carry Through" },
    { symbol: "糖", meaning: "Sugar" },
    { symbol: "頭", meaning: "Head, Counter For Large Animals" },
    { symbol: "謄", meaning: "Mimeograph, Copy" },
    { symbol: "藤", meaning: "Wisteria" },
    { symbol: "闘", meaning: "Fight, War" },
    { symbol: "騰", meaning: "Leaping Up, Jumping Up, Rising" },
    { symbol: "同", meaning: "Same, Agree, Equal" },
    { symbol: "洞", meaning: "Den, Cave, Excavation" },
    { symbol: "胴", meaning: "Trunk, Torso, Hull (ship)" },
    { symbol: "動", meaning: "Move, Motion, Change" },
    { symbol: "堂", meaning: "Public Chamber, Hall" },
    { symbol: "童", meaning: "Juvenile, Child" },
    { symbol: "道", meaning: "Road-way, Street, District" },
    { symbol: "働", meaning: "Work, (kokuji)" },
    { symbol: "銅", meaning: "Copper" },
    { symbol: "導", meaning: "Guidance, Leading, Conduct" },
    { symbol: "瞳", meaning: "Pupil (of Eye)" },
    { symbol: "峠", meaning: "Mountain Peak, Mountain Pass, Climax" },
    { symbol: "匿", meaning: "Hide, Shelter, Shield" },
    { symbol: "特", meaning: "Special" },
    { symbol: "得", meaning: "Gain, Get, Find" },
    { symbol: "督", meaning: "Coach, Command, Urge" },
    { symbol: "徳", meaning: "Benevolence, Virtue, Goodness" },
    { symbol: "篤", meaning: "Fervent, Kind, Cordial" },
    { symbol: "毒", meaning: "Poison, Virus, Venom" },
    { symbol: "独", meaning: "Single, Alone, Spontaneously" },
    { symbol: "読", meaning: "Read" },
    { symbol: "栃", meaning: "Horse Chestnut, (kokuji)" },
    { symbol: "凸", meaning: "Convex, Beetle Brow, Uneven" },
    { symbol: "突", meaning: "Stab, Protruding, Thrust" },
    { symbol: "届", meaning: "Deliver, Reach, Arrive" },
    { symbol: "屯", meaning: "Barracks, Police Station, Camp" },
    { symbol: "豚", meaning: "Pork, Pig" },
    { symbol: "頓", meaning: "Suddenly, Immediately, In A Hurry" },
    { symbol: "貪", meaning: "Covet, Indulge In" },
    { symbol: "鈍", meaning: "Dull, Slow, Foolish" },
    { symbol: "曇", meaning: "Cloudy Weather, Cloud Up" },
    { symbol: "丼", meaning: "Bowl, Bowl Of Food" },
    { symbol: "那", meaning: "What?" },
    { symbol: "奈", meaning: "Nara, What?" },
    { symbol: "内", meaning: "Inside, Within, Between" },
    { symbol: "梨", meaning: "Pear Tree" },
    { symbol: "謎", meaning: "Riddle, Puzzle, Enigma" },
    { symbol: "鍋", meaning: "Pot, Pan, Kettle" },
    { symbol: "南", meaning: "South" },
    { symbol: "軟", meaning: "Soft" },
    { symbol: "難", meaning: "Difficult, Impossible, Trouble" },
    { symbol: "二", meaning: "Two" },
    { symbol: "尼", meaning: "Nun" },
    { symbol: "弐", meaning: "Ii, Two, Second" },
    { symbol: "匂", meaning: "Fragrant, Stink, Glow" },
    { symbol: "肉", meaning: "Meat" },
    { symbol: "虹", meaning: "Rainbow" },
    { symbol: "日", meaning: "Day, Sun, Japan" },
    { symbol: "入", meaning: "Enter, Insert" },
    { symbol: "乳", meaning: "Milk, Breasts" },
    { symbol: "尿", meaning: "Urine" },
    { symbol: "任", meaning: "Responsibility, Duty, Term" },
    { symbol: "妊", meaning: "Pregnancy" },
    { symbol: "忍", meaning: "Endure, Bear, Put Up With" },
    { symbol: "認", meaning: "Acknowledge, Witness, Discern" },
    { symbol: "寧", meaning: "Rather, Preferably, Peaceful" },
    { symbol: "熱", meaning: "Heat, Temperature, Fever" },
    { symbol: "年", meaning: "Year, Counter For Years" },
    { symbol: "念", meaning: "Wish, Sense, Idea" },
    { symbol: "捻", meaning: "Twirl, Twist, Play With" },
    { symbol: "粘", meaning: "Sticky, Glutinous, Greasy" },
    { symbol: "燃", meaning: "Burn, Blaze, Glow" },
    { symbol: "悩", meaning: "Trouble, Worry, In Pain" },
    { symbol: "納", meaning: "Settlement, Obtain, Reap" },
    { symbol: "能", meaning: "Ability, Talent, Skill" },
    { symbol: "脳", meaning: "Brain, Memory" },
    { symbol: "農", meaning: "Agriculture, Farmers" },
    { symbol: "濃", meaning: "Concentrated, Thick, Dark" },
    { symbol: "把", meaning: "Grasp, Faggot, Bunch" },
    { symbol: "波", meaning: "Waves, Billows, Poland" },
    { symbol: "派", meaning: "Faction, Group, Party" },
    { symbol: "破", meaning: "Rend, Rip, Tear" },
    { symbol: "覇", meaning: "Hegemony, Supremacy, Leadership" },
    { symbol: "馬", meaning: "Horse" },
    { symbol: "婆", meaning: "Old Woman, Grandma, Wet Nurse" },
    { symbol: "罵", meaning: "Abuse, Insult" },
    { symbol: "拝", meaning: "Worship, Adore, Pray To" },
    { symbol: "杯", meaning: "Counter For Cupfuls, Wine Glass, Glass" },
    { symbol: "背", meaning: "Stature, Height, Back" },
    { symbol: "肺", meaning: "Lungs" },
    { symbol: "俳", meaning: "Haiku, Actor" },
    { symbol: "配", meaning: "Distribute, Spouse, Exile" },
    { symbol: "排", meaning: "Repudiate, Exclude, Expel" },
    { symbol: "敗", meaning: "Failure, Defeat, Reversal" },
    { symbol: "廃", meaning: "Abolish, Obsolete, Cessation" },
    { symbol: "輩", meaning: "Comrade, Fellow, People" },
    { symbol: "売", meaning: "Sell" },
    { symbol: "倍", meaning: "Double, Twice, Times" },
    { symbol: "梅", meaning: "Plum" },
    { symbol: "培", meaning: "Cultivate, Foster" },
    { symbol: "陪", meaning: "Obeisance, Follow, Accompany" },
    { symbol: "媒", meaning: "Mediator, Go-between" },
    { symbol: "買", meaning: "Buy" },
    { symbol: "賠", meaning: "Compensation, Indemnify" },
    { symbol: "白", meaning: "White" },
    { symbol: "伯", meaning: "Chief, Count, Earl" },
    { symbol: "拍", meaning: "Clap, Beat (music)" },
    { symbol: "泊", meaning: "Overnight Stay, Put Up At, Ride At Anchor" },
    { symbol: "迫", meaning: "Urge, Force, Imminent" },
    { symbol: "剝", meaning: "Peel, Come Off, Strip" },
    { symbol: "舶", meaning: "Liner, Ship" },
    { symbol: "博", meaning: "Dr., Command, Esteem" },
    { symbol: "薄", meaning: "Dilute, Thin, Weak (tea)" },
    { symbol: "麦", meaning: "Barley, Wheat" },
    { symbol: "漠", meaning: "Vague, Obscure, Desert" },
    { symbol: "縛", meaning: "Truss, Arrest, Bind" },
    { symbol: "爆", meaning: "Bomb, Burst Open, Pop" },
    { symbol: "箱", meaning: "Box, Chest, Case" },
    { symbol: "箸", meaning: "Chopsticks" },
    { symbol: "畑", meaning: "Farm, Field, Garden" },
    { symbol: "肌", meaning: "Texture, Skin, Body" },
    { symbol: "八", meaning: "Eight" },
    { symbol: "鉢", meaning: "Bowl, Rice Tub, Pot" },
    { symbol: "発", meaning: "Departure, Discharge, Publish" },
    { symbol: "髪", meaning: "Hair Of The Head" },
    { symbol: "伐", meaning: "Fell, Strike, Attack" },
    { symbol: "抜", meaning: "Slip Out, Extract, Pull Out" },
    { symbol: "罰", meaning: "Penalty, Punishment" },
    { symbol: "閥", meaning: "Clique, Lineage, Pedigree" },
    { symbol: "反", meaning: "Anti-" },
    { symbol: "半", meaning: "Half, Middle, Odd Number" },
    { symbol: "氾", meaning: "Spread Out, Wide" },
    { symbol: "犯", meaning: "Crime, Sin, Offense" },
    { symbol: "帆", meaning: "Sail" },
    { symbol: "汎", meaning: "Pan-" },
    { symbol: "伴", meaning: "Consort, Accompany, Bring With" },
    { symbol: "判", meaning: "Judgement, Signature, Stamp" },
    { symbol: "坂", meaning: "Slope, Incline, Hill" },
    { symbol: "阪", meaning: "Heights, Slope" },
    { symbol: "板", meaning: "Plank, Board, Plate" },
    { symbol: "版", meaning: "Printing Block, Printing Plate, Edition" },
    { symbol: "班", meaning: "Squad, Corps, Unit" },
    { symbol: "畔", meaning: "Paddy Ridge, Levee" },
    { symbol: "般", meaning: "Carrier, Carry, All" },
    { symbol: "販", meaning: "Marketing, Sell, Trade" },
    { symbol: "斑", meaning: "Spot, Blemish, Speck" },
    { symbol: "飯", meaning: "Meal, Boiled Rice" },
    { symbol: "搬", meaning: "Conveyor, Carry, Transport" },
    { symbol: "煩", meaning: "Anxiety, Trouble, Worry" },
    { symbol: "頒", meaning: "Distribute, Disseminate, Partition" },
    { symbol: "範", meaning: "Pattern, Example, Model" },
    { symbol: "繁", meaning: "Luxuriant, Thick, Overgrown" },
    { symbol: "藩", meaning: "Clan, Enclosure" },
    { symbol: "晩", meaning: "Nightfall, Night" },
    { symbol: "番", meaning: "Turn, Number In A Series" },
    { symbol: "蛮", meaning: "Barbarian" },
    { symbol: "盤", meaning: "Tray, Shallow Bowl, Platter" },
    { symbol: "比", meaning: "Compare, Race, Ratio" },
    { symbol: "皮", meaning: "Pelt, Skin, Hide" },
    { symbol: "妃", meaning: "Queen, Princess" },
    { symbol: "否", meaning: "Negate, No, Noes" },
    { symbol: "批", meaning: "Criticism, Strike" },
    { symbol: "彼", meaning: "He, That, The" },
    { symbol: "披", meaning: "Expose, Open" },
    { symbol: "肥", meaning: "Fertilizer, Get Fat, Fertile" },
    { symbol: "非", meaning: "Un-, Mistake, Negative" },
    { symbol: "卑", meaning: "Lowly, Base, Vile" },
    { symbol: "飛", meaning: "Fly, Skip (pages), Scatter" },
    { symbol: "疲", meaning: "Exhausted, Tire, Weary" },
    { symbol: "秘", meaning: "Secret, Conceal" },
    { symbol: "被", meaning: "Incur, Cover, Veil" },
    { symbol: "悲", meaning: "Grieve, Sad, Deplore" },
    { symbol: "扉", meaning: "Front Door, Title Page, Front Page" },
    { symbol: "費", meaning: "Expense, Cost, Spend" },
    { symbol: "碑", meaning: "Tombstone, Monument" },
    { symbol: "罷", meaning: "Quit, Stop, Leave" },
    { symbol: "避", meaning: "Evade, Avoid, Avert" },
    { symbol: "尾", meaning: "Tail, End, Counter For Fish" },
    { symbol: "眉", meaning: "Eyebrow" },
    { symbol: "美", meaning: "Beauty, Beautiful" },
    { symbol: "備", meaning: "Equip, Provision, Preparation" },
    { symbol: "微", meaning: "Delicate, Minuteness, Insignificance" },
    { symbol: "鼻", meaning: "Nose, Snout" },
    { symbol: "膝", meaning: "Knee, Lap" },
    { symbol: "肘", meaning: "Elbow, Arm" },
    { symbol: "匹", meaning: "Equal, Head, Counter For Small Animals" },
    { symbol: "必", meaning: "Invariably, Certain, Inevitable" },
    { symbol: "泌", meaning: "Ooze, Flow, Soak In" },
    { symbol: "筆", meaning: "Writing Brush, Writing, Painting Brush" },
    { symbol: "姫", meaning: "Princess" },
    { symbol: "百", meaning: "Hundred" },
    { symbol: "氷", meaning: "Icicle, Ice, Hail" },
    { symbol: "表", meaning: "Surface, Table, Chart" },
    { symbol: "俵", meaning: "Bag, Bale, Sack" },
    { symbol: "票", meaning: "Ballot, Label, Ticket" },
    { symbol: "評", meaning: "Evaluate, Criticism, Comment" },
    { symbol: "漂", meaning: "Drift, Float (on Liquid)" },
    { symbol: "標", meaning: "Signpost, Seal, Mark" },
    { symbol: "苗", meaning: "Seedling, Sapling, Shoot" },
    { symbol: "秒", meaning: "Second (1/60 Minute)" },
    { symbol: "病", meaning: "Ill, Sick" },
    { symbol: "描", meaning: "Sketch, Compose, Write" },
    { symbol: "猫", meaning: "Cat" },
    { symbol: "品", meaning: "Goods, Refinement, Dignity" },
    { symbol: "浜", meaning: "Seacoast, Beach, Seashore" },
    { symbol: "貧", meaning: "Poverty, Poor" },
    { symbol: "賓", meaning: "V.i.p., Guest" },
    { symbol: "頻", meaning: "Repeatedly, Recur" },
    { symbol: "敏", meaning: "Cleverness, Agile, Alert" },
    { symbol: "瓶", meaning: "Bottle, Vial, Jar" },
    { symbol: "不", meaning: "Negative, Non-, Bad" },
    { symbol: "夫", meaning: "Husband, Man" },
    { symbol: "父", meaning: "Father" },
    { symbol: "付", meaning: "Adhere, Attach, Refer To" },
    { symbol: "布", meaning: "Linen, Cloth, Spread" },
    { symbol: "扶", meaning: "Aid, Help, Assist" },
    { symbol: "府", meaning: "Borough, Urban Prefecture, Govt Office" },
    { symbol: "怖", meaning: "Dreadful, Be Frightened, Fearful" },
    { symbol: "阜", meaning: "Hill, Mound" },
    { symbol: "附", meaning: "Affixed, Attach, Refer To" },
    { symbol: "訃", meaning: "Obituary" },
    { symbol: "負", meaning: "Defeat, Negative, -" },
    { symbol: "赴", meaning: "Proceed, Get, Become" },
    { symbol: "浮", meaning: "Floating, Float, Rise To Surface" },
    { symbol: "婦", meaning: "Lady, Woman, Wife" },
    { symbol: "符", meaning: "Token, Sign, Mark" },
    { symbol: "富", meaning: "Wealth, Enrich, Abundant" },
    { symbol: "普", meaning: "Universal, Wide(ly), Generally" },
    { symbol: "腐", meaning: "Rot, Decay, Sour" },
    { symbol: "敷", meaning: "Spread, Pave, Sit" },
    { symbol: "膚", meaning: "Skin, Body, Grain" },
    { symbol: "賦", meaning: "Levy, Ode, Prose" },
    { symbol: "譜", meaning: "Musical Score, Music, Note" },
    { symbol: "侮", meaning: "Scorn, Despise, Make Light Of" },
    { symbol: "武", meaning: "Warrior, Military, Chivalry" },
    { symbol: "部", meaning: "Section, Bureau, Dept" },
    { symbol: "舞", meaning: "Dance, Flit, Circle" },
    { symbol: "封", meaning: "Seal, Closing" },
    { symbol: "風", meaning: "Wind, Air, Style" },
    { symbol: "伏", meaning: "Prostrated, Bend Down, Bow" },
    { symbol: "服", meaning: "Clothing, Admit, Obey" },
    { symbol: "副", meaning: "Vice-, Assistant, Aide" },
    { symbol: "幅", meaning: "Hanging Scroll, Width" },
    { symbol: "復", meaning: "Restore, Return To, Revert" },
    { symbol: "福", meaning: "Blessing, Fortune, Luck" },
    { symbol: "腹", meaning: "Abdomen, Belly, Stomach" },
    { symbol: "複", meaning: "Duplicate, Double, Compound" },
    { symbol: "覆", meaning: "Capsize, Cover, Shade" },
    { symbol: "払", meaning: "Pay, Clear Out, Prune" },
    { symbol: "沸", meaning: "Seethe, Boil, Ferment" },
    { symbol: "仏", meaning: "Buddha, The Dead, France" },
    { symbol: "物", meaning: "Thing, Object, Matter" },
    { symbol: "粉", meaning: "Flour, Powder, Dust" },
    { symbol: "紛", meaning: "Distract, Be Mistaken For, Go Astray" },
    { symbol: "雰", meaning: "Atmosphere, Fog" },
    { symbol: "噴", meaning: "Erupt, Spout, Emit" },
    { symbol: "墳", meaning: "Tomb, Mound" },
    { symbol: "憤", meaning: "Aroused, Resent, Be Indignant" },
    { symbol: "奮", meaning: "Stirred Up, Be Invigorated, Flourish" },
    { symbol: "分", meaning: "Part, Minute Of Time, Segment" },
    { symbol: "文", meaning: "Sentence, Literature, Style" },
    { symbol: "聞", meaning: "Hear, Ask, Listen" },
    { symbol: "丙", meaning: "Third Class, 3rd, 3rd Calendar Sign" },
    { symbol: "平", meaning: "Even, Flat, Peace" },
    { symbol: "兵", meaning: "Soldier, Private, Troops" },
    { symbol: "併", meaning: "Join, Get Together, Unite" },
    { symbol: "並", meaning: "Row, And, Besides" },
    { symbol: "柄", meaning: "Design, Pattern, Build" },
    { symbol: "陛", meaning: "Highness, Steps (of Throne)" },
    { symbol: "閉", meaning: "Closed, Shut" },
    { symbol: "塀", meaning: "Fence, Wall, (kokuji)" },
    { symbol: "幣", meaning: "Cash, Bad Habit, Humble Prefix" },
    { symbol: "弊", meaning: "Abuse, Evil, Vice" },
    { symbol: "蔽", meaning: "Cover, Shade, Mantle" },
    { symbol: "餅", meaning: "Mochi Rice Cake" },
    { symbol: "米", meaning: "Rice, Usa, Metre" },
    { symbol: "壁", meaning: "Wall, Lining (stomach), Fence" },
    { symbol: "璧", meaning: "Sphere, Ball" },
    { symbol: "癖", meaning: "Mannerism, Habit, Vice" },
    { symbol: "別", meaning: "Separate, Branch Off, Diverge" },
    { symbol: "蔑", meaning: "Ignore, Despise, Neglect" },
    { symbol: "片", meaning: "One-sided, Leaf, Sheet" },
    { symbol: "辺", meaning: "Environs, Boundary, Border" },
    { symbol: "返", meaning: "Return, Answer, Fade" },
    { symbol: "変", meaning: "Unusual, Change, Strange" },
    { symbol: "偏", meaning: "Partial, Side, Inclining" },
    { symbol: "遍", meaning: "Everywhere, Times, Widely" },
    { symbol: "編", meaning: "Compilation, Knit, Plait" },
    { symbol: "弁", meaning: "Valve, Petal, Braid" },
    { symbol: "便", meaning: "Convenience, Facility, Excrement" },
    { symbol: "勉", meaning: "Exertion, Endeavour, Encourage" },
    { symbol: "歩", meaning: "Walk, Counter For Steps" },
    { symbol: "保", meaning: "Protect, Guarantee, Keep" },
    { symbol: "哺", meaning: "Nurse, Suckle" },
    { symbol: "捕", meaning: "Catch, Capture" },
    { symbol: "補", meaning: "Supplement, Supply, Make Good" },
    { symbol: "舗", meaning: "Shop, Store, Pave" },
    { symbol: "母", meaning: "Mother" },
    { symbol: "募", meaning: "Recruit, Campaign, Gather (contributions)" },
    { symbol: "墓", meaning: "Grave, Tomb" },
    { symbol: "慕", meaning: "Pining, Yearn For, Love Dearly" },
    { symbol: "暮", meaning: "Evening, Twilight, Season's End" },
    { symbol: "簿", meaning: "Register, Record Book" },
    { symbol: "方", meaning: "Direction, Person, Alternative" },
    { symbol: "包", meaning: "Wrap, Pack Up, Cover" },
    { symbol: "芳", meaning: "Perfume, Balmy, Favorable" },
    { symbol: "邦", meaning: "Home Country, Country, Japan" },
    { symbol: "奉", meaning: "Observance, Offer, Present" },
    { symbol: "宝", meaning: "Treasure, Wealth, Valuables" },
    { symbol: "抱", meaning: "Embrace, Hug, Hold In Arms" },
    { symbol: "放", meaning: "Set Free, Release, Fire" },
    { symbol: "法", meaning: "Method, Law, Rule" },
    { symbol: "泡", meaning: "Bubbles, Foam, Suds" },
    { symbol: "胞", meaning: "Placenta, Sac, Sheath" },
    { symbol: "俸", meaning: "Stipend, Salary" },
    { symbol: "倣", meaning: "Emulate, Imitate" },
    { symbol: "峰", meaning: "Summit, Peak" },
    { symbol: "砲", meaning: "Cannon, Gun" },
    { symbol: "崩", meaning: "Crumble, Die, Demolish" },
    { symbol: "訪", meaning: "Call On, Visit, Look Up" },
    { symbol: "報", meaning: "Report, News, Reward" },
    { symbol: "蜂", meaning: "Bee, Wasp, Hornet" },
    { symbol: "豊", meaning: "Bountiful, Excellent, Rich" },
    { symbol: "飽", meaning: "Sated, Tired Of, Bored" },
    { symbol: "褒", meaning: "Praise, Extol" },
    { symbol: "縫", meaning: "Sew, Stitch, Embroider" },
    { symbol: "亡", meaning: "Deceased, The Late, Dying" },
    { symbol: "乏", meaning: "Destitution, Scarce, Limited" },
    { symbol: "忙", meaning: "Busy, Occupied, Restless" },
    { symbol: "坊", meaning: "Boy, Priest's Residence, Priest" },
    { symbol: "妨", meaning: "Disturb, Prevent, Hamper" },
    { symbol: "忘", meaning: "Forget" },
    { symbol: "防", meaning: "Ward Off, Defend, Protect" },
    { symbol: "房", meaning: "Tassel, Tuft, Fringe" },
    { symbol: "肪", meaning: "Obese, Fat" },
    { symbol: "某", meaning: "So-and-so, One, A Certain" },
    { symbol: "冒", meaning: "Risk, Face, Defy" },
    { symbol: "剖", meaning: "Divide" },
    { symbol: "紡", meaning: "Spinning" },
    { symbol: "望", meaning: "Ambition, Full Moon, Hope" },
    { symbol: "傍", meaning: "Bystander, Side, Besides" },
    { symbol: "帽", meaning: "Cap, Headgear" },
    { symbol: "棒", meaning: "Rod, Stick, Cane" },
    { symbol: "貿", meaning: "Trade, Exchange" },
    { symbol: "貌", meaning: "Form, Appearance, Countenance" },
    { symbol: "暴", meaning: "Outburst, Rave, Fret" },
    { symbol: "膨", meaning: "Swell, Get Fat, Thick" },
    { symbol: "謀", meaning: "Conspire, Cheat, Impose On" },
    { symbol: "頰", meaning: "Cheeks, Jaw" },
    { symbol: "北", meaning: "North" },
    { symbol: "木", meaning: "Tree, Wood" },
    { symbol: "朴", meaning: "Crude, Simple, Plain" },
    { symbol: "牧", meaning: "Breed, Care For, Shepherd" },
    { symbol: "睦", meaning: "Intimate, Friendly, Harmonious" },
    { symbol: "僕", meaning: "Me, I (male), Servant" },
    { symbol: "墨", meaning: "Black Ink, India Ink, Ink Stick" },
    { symbol: "撲", meaning: "Slap, Strike, Hit" },
    { symbol: "没", meaning: "Drown, Sink, Hide" },
    { symbol: "勃", meaning: "Suddenness, Rise" },
    { symbol: "堀", meaning: "Ditch, Moat, Canal" },
    { symbol: "本", meaning: "Book, Present, Main" },
    { symbol: "奔", meaning: "Run, Bustle" },
    { symbol: "翻", meaning: "Flip, Turn Over, Wave" },
    { symbol: "凡", meaning: "Commonplace, Ordinary, Mediocre" },
    { symbol: "盆", meaning: "Basin, Lantern Festival, Tray" },
    { symbol: "麻", meaning: "Hemp, Flax, Numb" },
    { symbol: "摩", meaning: "Chafe, Rub, Polish" },
    { symbol: "磨", meaning: "Grind, Polish, Scour" },
    { symbol: "魔", meaning: "Witch, Demon, Evil Spirit" },
    { symbol: "毎", meaning: "Every" },
    { symbol: "妹", meaning: "Younger Sister" },
    { symbol: "枚", meaning: "Sheet Of..., Counter For Flat Thin Objects Or Sheets" },
    { symbol: "昧", meaning: "Dark, Foolish" },
    { symbol: "埋", meaning: "Bury, Be Filled Up, Embedded" },
    { symbol: "幕", meaning: "Curtain, Bunting, Act Of Play" },
    { symbol: "膜", meaning: "Membrane" },
    { symbol: "枕", meaning: "Pillow" },
    { symbol: "又", meaning: "Or Again, Furthermore, On The Other Hand" },
    { symbol: "末", meaning: "End, Close, Tip" },
    { symbol: "抹", meaning: "Rub, Paint, Erase" },
    { symbol: "万", meaning: "Ten Thousand, 10,000" },
    { symbol: "満", meaning: "Full, Fullness, Enough" },
    { symbol: "慢", meaning: "Ridicule, Laziness" },
    { symbol: "漫", meaning: "Cartoon, Involuntarily, Unrestrained" },
    { symbol: "未", meaning: "Un-, Not Yet, Hitherto" },
    { symbol: "味", meaning: "Flavor, Taste" },
    { symbol: "魅", meaning: "Fascination, Charm, Bewitch" },
    { symbol: "岬", meaning: "Headland, Cape, Spit" },
    { symbol: "密", meaning: "Secrecy, Density (pop), Minuteness" },
    { symbol: "蜜", meaning: "Honey, Nectar, Molasses" },
    { symbol: "脈", meaning: "Vein, Pulse, Hope" },
    { symbol: "妙", meaning: "Exquisite, Strange, Queer" },
    { symbol: "民", meaning: "People, Nation, Subjects" },
    { symbol: "眠", meaning: "Sleep, Die, Sleepy" },
    { symbol: "矛", meaning: "Halberd, Arms, Festival Float" },
    { symbol: "務", meaning: "Task, Duties" },
    { symbol: "無", meaning: "Nothingness, None, Ain't" },
    { symbol: "夢", meaning: "Dream, Vision, Illusion" },
    { symbol: "霧", meaning: "Fog, Mist" },
    { symbol: "娘", meaning: "Daughter, Girl" },
    { symbol: "名", meaning: "Name, Noted, Distinguished" },
    { symbol: "命", meaning: "Fate, Command, Decree" },
    { symbol: "明", meaning: "Bright, Light" },
    { symbol: "迷", meaning: "Astray, Be Perplexed, In Doubt" },
    { symbol: "冥", meaning: "Dark" },
    { symbol: "盟", meaning: "Alliance, Oath" },
    { symbol: "銘", meaning: "Inscription, Signature (of Artisan)" },
    { symbol: "鳴", meaning: "Chirp, Cry, Bark" },
    { symbol: "滅", meaning: "Destroy, Ruin, Overthrow" },
    { symbol: "免", meaning: "Excuse, Dismissal" },
    { symbol: "面", meaning: "Mask, Face, Features" },
    { symbol: "綿", meaning: "Cotton" },
    { symbol: "麺", meaning: "Noodles, Wheat Flour" },
    { symbol: "茂", meaning: "Overgrown, Grow Thick, Be Luxuriant" },
    { symbol: "模", meaning: "Imitation, Copy, Mock" },
    { symbol: "毛", meaning: "Fur, Hair, Feather" },
    { symbol: "妄", meaning: "Delusion, Unnecessarily, Without Authority" },
    { symbol: "盲", meaning: "Blind, Blind Man, Ignoramus" },
    { symbol: "耗", meaning: "Decrease" },
    { symbol: "猛", meaning: "Fierce, Rave, Rush" },
    { symbol: "網", meaning: "Netting, Network" },
    { symbol: "目", meaning: "Eye, Class, Look" },
    { symbol: "黙", meaning: "Silence, Become Silent, Stop Speaking" },
    { symbol: "門", meaning: "Gate, Counter For Cannons" },
    { symbol: "紋", meaning: "Family Crest, Figures" },
    { symbol: "問", meaning: "Question, Ask, Problem" },
    { symbol: "冶", meaning: "Melting, Smelting" },
    { symbol: "夜", meaning: "Night, Evening" },
    { symbol: "野", meaning: "Plains, Field, Rustic" },
    { symbol: "弥", meaning: "All The More, Increasingly" },
    { symbol: "厄", meaning: "Unlucky, Misfortune, Bad Luck" },
    { symbol: "役", meaning: "Duty, War, Campaign" },
    { symbol: "約", meaning: "Promise, Approximately, Shrink" },
    { symbol: "訳", meaning: "Translate, Reason, Circumstance" },
    { symbol: "薬", meaning: "Medicine, Chemical, Enamel" },
    { symbol: "躍", meaning: "Leap, Dance, Skip" },
    { symbol: "闇", meaning: "Get Dark, Gloom, Disorder" },
    { symbol: "由", meaning: "Wherefore, A Reason" },
    { symbol: "油", meaning: "Oil, Fat" },
    { symbol: "喩", meaning: "Metaphor, Compare" },
    { symbol: "愉", meaning: "Pleasure, Happy, Rejoice" },
    { symbol: "諭", meaning: "Rebuke, Admonish, Charge" },
    { symbol: "輸", meaning: "Transport, Send, Be Inferior" },
    { symbol: "癒", meaning: "Healing, Cure, Quench (thirst)" },
    { symbol: "唯", meaning: "Solely, Only, Merely" },
    { symbol: "友", meaning: "Friend" },
    { symbol: "有", meaning: "Possess, Have, Exist" },
    { symbol: "勇", meaning: "Courage, Cheer Up, Be In High Spirits" },
    { symbol: "幽", meaning: "Seclude, Confine To A Room, Deep" },
    { symbol: "悠", meaning: "Permanence, Distant, Long Time" },
    { symbol: "郵", meaning: "Mail, Stagecoach Stop" },
    { symbol: "湧", meaning: "Boil, Ferment, Seethe" },
    { symbol: "猶", meaning: "Furthermore, Still, Yet" },
    { symbol: "裕", meaning: "Abundant, Rich, Fertile" },
    { symbol: "遊", meaning: "Play" },
    { symbol: "雄", meaning: "Masculine, Male, Hero" },
    { symbol: "誘", meaning: "Entice, Lead, Tempt" },
    { symbol: "憂", meaning: "Melancholy, Grieve, Lament" },
    { symbol: "融", meaning: "Dissolve, Melt" },
    { symbol: "優", meaning: "Tenderness, Excel, Surpass" },
    { symbol: "与", meaning: "Bestow, Participate In, Give" },
    { symbol: "予", meaning: "Beforehand, Previous, Myself" },
    { symbol: "余", meaning: "Too Much, Myself, Surplus" },
    { symbol: "誉", meaning: "Reputation, Praise, Honor" },
    { symbol: "預", meaning: "Deposit, Custody, Leave With" },
    { symbol: "幼", meaning: "Infancy, Childhood" },
    { symbol: "用", meaning: "Utilize, Business, Service" },
    { symbol: "羊", meaning: "Sheep" },
    { symbol: "妖", meaning: "Attractive, Bewitching, Calamity" },
    { symbol: "洋", meaning: "Ocean, Sea, Foreign" },
    { symbol: "要", meaning: "Need, Main Point, Essence" },
    { symbol: "容", meaning: "Contain, Form, Looks" },
    { symbol: "庸", meaning: "Commonplace, Ordinary, Employment" },
    { symbol: "揚", meaning: "Raise, Elevate, Hoist" },
    { symbol: "揺", meaning: "Swing, Shake, Sway" },
    { symbol: "葉", meaning: "Leaf, Plane, Lobe" },
    { symbol: "陽", meaning: "Sunshine, Yang Principle, Positive" },
    { symbol: "溶", meaning: "Melt, Dissolve, Thaw" },
    { symbol: "腰", meaning: "Loins, Hips, Waist" },
    { symbol: "様", meaning: "Esq., Way, Manner" },
    { symbol: "瘍", meaning: "Swelling, Boil, Tumor" },
    { symbol: "踊", meaning: "Jump, Dance, Leap" },
    { symbol: "窯", meaning: "Kiln, Oven, Furnace" },
    { symbol: "養", meaning: "Foster, Bring Up, Rear" },
    { symbol: "擁", meaning: "Hug, Embrace, Possess" },
    { symbol: "謡", meaning: "Song, Sing, Ballad" },
    { symbol: "曜", meaning: "Weekday" },
    { symbol: "抑", meaning: "Repress, Well, Now" },
    { symbol: "沃", meaning: "Fertility" },
    { symbol: "浴", meaning: "Bathe, Be Favored With, Bask In" },
    { symbol: "欲", meaning: "Longing, Covetousness, Greed" },
    { symbol: "翌", meaning: "The Following, Next" },
    { symbol: "翼", meaning: "Wing, Plane, Flank" },
    { symbol: "拉", meaning: "Latin, Kidnap, Crush" },
    { symbol: "裸", meaning: "Naked, Nude, Uncovered" },
    { symbol: "羅", meaning: "Gauze, Thin Silk, Rome" },
    { symbol: "来", meaning: "Come, Due, Next" },
    { symbol: "雷", meaning: "Thunder, Lightning Bolt" },
    { symbol: "頼", meaning: "Trust, Request" },
    { symbol: "絡", meaning: "Entwine, Coil Around, Get Caught In" },
    { symbol: "落", meaning: "Fall, Drop, Come Down" },
    { symbol: "酪", meaning: "Dairy Products, Whey, Broth" },
    { symbol: "辣", meaning: "Pungent, Spicy, Harsh" },
    { symbol: "乱", meaning: "Riot, War, Disorder" },
    { symbol: "卵", meaning: "Egg, Ovum, Spawn" },
    { symbol: "覧", meaning: "Perusal, See" },
    { symbol: "濫", meaning: "Excessive, Overflow, Spread Out" },
    { symbol: "藍", meaning: "Indigo" },
    { symbol: "欄", meaning: "Column, Handrail, Blank" },
    { symbol: "吏", meaning: "Officer, An Official" },
    { symbol: "利", meaning: "Profit, Advantage, Benefit" },
    { symbol: "里", meaning: "Ri, Village, Parent's Home" },
    { symbol: "理", meaning: "Logic, Arrangement, Reason" },
    { symbol: "痢", meaning: "Diarrhea" },
    { symbol: "裏", meaning: "Back, Amidst, In" },
    { symbol: "履", meaning: "Perform, Complete, Footgear" },
    { symbol: "璃", meaning: "Glassy, Lapis Lazuli" },
    { symbol: "離", meaning: "Detach, Separation, Disjoin" },
    { symbol: "陸", meaning: "Land, Six" },
    { symbol: "立", meaning: "Stand Up, Rise, Set Up" },
    { symbol: "律", meaning: "Rhythm, Law, Regulation" },
    { symbol: "慄", meaning: "Fear" },
    { symbol: "略", meaning: "Abbreviation, Omission, Outline" },
    { symbol: "柳", meaning: "Willow" },
    { symbol: "流", meaning: "Current, A Sink, Flow" },
    { symbol: "留", meaning: "Detain, Fasten, Halt" },
    { symbol: "竜", meaning: "Dragon, Imperial" },
    { symbol: "粒", meaning: "Grains, Drop, Counter For Tiny Particles" },
    { symbol: "隆", meaning: "Hump, High, Noble" },
    { symbol: "硫", meaning: "Sulphur" },
    { symbol: "侶", meaning: "Companion, Follower" },
    { symbol: "旅", meaning: "Trip, Travel" },
    { symbol: "虜", meaning: "Captive, Barbarian, Low Epithet For The Enemy" },
    { symbol: "慮", meaning: "Prudence, Thought, Concern" },
    { symbol: "了", meaning: "Complete, Finish" },
    { symbol: "両", meaning: "Both, Old Japanese Coin, Counter For Carriages (e.g., In A Train)" },
    { symbol: "良", meaning: "Good, Pleasing, Skilled" },
    { symbol: "料", meaning: "Fee, Materials" },
    { symbol: "涼", meaning: "Refreshing, Nice And Cool" },
    { symbol: "猟", meaning: "Game-hunting, Shooting, Game" },
    { symbol: "陵", meaning: "Mausoleum, Imperial Tomb, Mound" },
    { symbol: "量", meaning: "Quantity, Measure, Weight" },
    { symbol: "僚", meaning: "Colleague, Official, Companion" },
    { symbol: "領", meaning: "Jurisdiction, Dominion, Territory" },
    { symbol: "寮", meaning: "Dormitory, Hostel, Villa" },
    { symbol: "療", meaning: "Heal, Cure" },
    { symbol: "瞭", meaning: "Clear" },
    { symbol: "糧", meaning: "Provisions, Food, Bread" },
    { symbol: "力", meaning: "Power, Strength, Strong" },
    { symbol: "緑", meaning: "Green" },
    { symbol: "林", meaning: "Grove, Forest" },
    { symbol: "厘", meaning: "Rin, 1/10 Sen, 1/10 Bu" },
    { symbol: "倫", meaning: "Ethics, Companion" },
    { symbol: "輪", meaning: "Wheel, Ring, Circle" },
    { symbol: "隣", meaning: "Neighboring" },
    { symbol: "臨", meaning: "Look To, Face, Meet" },
    { symbol: "瑠", meaning: "Lapis Lazuli" },
    { symbol: "涙", meaning: "Tears, Sympathy" },
    { symbol: "累", meaning: "Accumulate, Involvement, Trouble" },
    { symbol: "塁", meaning: "Bases, Fort, Rampart" },
    { symbol: "類", meaning: "Sort, Kind, Variety" },
    { symbol: "令", meaning: "Orders, Ancient Laws, Command" },
    { symbol: "礼", meaning: "Salute, Bow, Ceremony" },
    { symbol: "冷", meaning: "Cool, Cold (beer, Person), Chill" },
    { symbol: "励", meaning: "Encourage, Be Diligent, Inspire" },
    { symbol: "戻", meaning: "Re-, Return, Revert" },
    { symbol: "例", meaning: "Example, Custom, Usage" },
    { symbol: "鈴", meaning: "Small Bell, Buzzer" },
    { symbol: "零", meaning: "Zero, Spill, Overflow" },
    { symbol: "霊", meaning: "Spirits, Soul" },
    { symbol: "隷", meaning: "Slave, Servant, Prisoner" },
    { symbol: "齢", meaning: "Age" },
    { symbol: "麗", meaning: "Lovely, Beautiful, Graceful" },
    { symbol: "暦", meaning: "Calendar, Almanac" },
    { symbol: "歴", meaning: "Curriculum, Continuation, Passage Of Time" },
    { symbol: "列", meaning: "File, Row, Rank" },
    { symbol: "劣", meaning: "Inferiority, Be Inferior To, Be Worse" },
    { symbol: "烈", meaning: "Ardent, Violent, Vehement" },
    { symbol: "裂", meaning: "Split, Rend, Tear" },
    { symbol: "恋", meaning: "Romance, In Love, Yearn For" },
    { symbol: "連", meaning: "Take Along, Lead, Join" },
    { symbol: "廉", meaning: "Bargain, Reason, Charge" },
    { symbol: "練", meaning: "Practice, Gloss, Train" },
    { symbol: "錬", meaning: "Tempering, Refine, Drill" },
    { symbol: "呂", meaning: "Spine, Backbone" },
    { symbol: "炉", meaning: "Hearth, Furnace, Kiln" },
    { symbol: "賂", meaning: "Bribe" },
    { symbol: "路", meaning: "Path, Route, Road" },
    { symbol: "露", meaning: "Dew, Tears, Expose" },
    { symbol: "老", meaning: "Old Man, Old Age, Grow Old" },
    { symbol: "労", meaning: "Labor, Thank For, Reward For" },
    { symbol: "弄", meaning: "Play With, Tamper, Trifle With" },
    { symbol: "郎", meaning: "Son, Counter For Sons" },
    { symbol: "朗", meaning: "Melodious, Clear, Bright" },
    { symbol: "浪", meaning: "Wandering, Waves, Billows" },
    { symbol: "廊", meaning: "Corridor, Hall, Tower" },
    { symbol: "楼", meaning: "Watchtower, Lookout, High Building" },
    { symbol: "漏", meaning: "Leak, Escape, Time" },
    { symbol: "籠", meaning: "Basket, Devote Oneself, Seclude Oneself" },
    { symbol: "六", meaning: "Six" },
    { symbol: "録", meaning: "Record" },
    { symbol: "麓", meaning: "Foot Of A Mountain" },
    { symbol: "論", meaning: "Argument, Discourse" },
    { symbol: "和", meaning: "Harmony, Japanese Style, Peace" },
    { symbol: "話", meaning: "Tale, Talk" },
    { symbol: "賄", meaning: "Bribe, Board, Supply" },
    { symbol: "脇", meaning: "Armpit, The Other Way, Another Place" },
    { symbol: "惑", meaning: "Beguile, Delusion, Perplexity" },
    { symbol: "枠", meaning: "Frame, Framework, Spindle" },
    { symbol: "湾", meaning: "Gulf, Bay, Inlet" },
    { symbol: "腕", meaning: "Arm, Ability, Talent" },
];
